import { Land } from 'src/app/Models/Classes/Publications/Land/land';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AlertController,
  ModalController,
  NavController,
  IonToggle
} from '@ionic/angular';
import { PublicationService } from 'src/app/services/publications/publication.service';
import { CameraServiceService } from 'src/app/services/multimedia/camera-service.service';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { Utils } from 'src/app/Models/Classes/utils';
import { Capacitor } from '@capacitor/core';
import Swal2 from 'sweetalert2';
import { RequestService } from 'src/app/services/request/request.service';
import { isVideo,isImage } from 'src/app/utils';
import { UploadMultimediaService } from './../../../../services/upload/upload-multimedia.service';
import { element } from 'protractor';
import { PrincipalPublicationComponent } from './../principal-components/principal-publication/principal-publication.component';
import { MyFeedPagePage } from './../../../../pages/my-feed-page/my-feed-page.page';
import { Browser } from '@capacitor/browser';
import { GoogleAccountAuthService } from 'src/app/services/auth/google-account-auth.service';
import { SocialAccountAuthService } from 'src/app/services/auth/social-account-auth.service';
import { ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

type InstagramDestination = 'FEED' | 'STORIES' | 'REELS';

@Component({
  selector: 'app-descripcion-publication',
  templateUrl: './descripcion-publication.component.html',
  styleUrls: ['./descripcion-publication.component.scss'],
})
export class DescripcionPublicationComponent implements OnInit, OnDestroy {
  @Input() startInPreview = false;
  public publicationSummaryVisible = false;
  public publicationSummaryPreview: any[] = [];
  // The summary needs to reveal publication details, but must not overwrite
  // the viewer's visibility preference after the composer closes.
  private showMoreHiddenBeforePublicationSummary: boolean | null = null;
  private showMorePreferenceChangedBeforePublicationSummary: boolean | null = null;
  private readonly linkedInCommentaryMaxLength = 3000;
  private readonly linkedInCommentarySafeLength = this.linkedInCommentaryMaxLength - 9;
  private readonly facebookMessageMaxLength = 63206;
  private readonly facebookMessageSafeLength = this.facebookMessageMaxLength - 9;
  private wixPostSent: boolean = false;
  // Wix is called after its media upload; retain the composer copy before a
  // successful local post clears the form.
  private wixPostTitle = '';
  private wixPostDescription = '';
  private instagramStoryVideoPromises = new Map<string, Promise<string>>();
  private xVideoPromises = new Map<string, Promise<string>>();
  private readonly instagramStoryMaxDurationSeconds = 59.5;

  /** Non-blocking status surface for asynchronous social publishing. */
  private setThirdPartyPublishStatus(
    state: 'processing' | 'success' | 'error',
    message: string,
    clearAfterMs = 0,
  ): void {
    this.uploadmultimedia.showThirdPartyPublishStatus(state, message, clearAfterMs);
  }
  private watermarkLogoPromise?: Promise<HTMLImageElement>;

  @ViewChild('threads_toggleElement') threads_toggleElement: IonToggle;
  threads_id;



  @ViewChild('youTube_toggleElement') youTube_toggleElement: IonToggle;
  youtube_email;
  private checkingYouTubeConnection = false;

  @Input() audio_duration;
  @Input() audio_start_value;

  browsersEnabled;
  laniakea_image_url: string = '';
  navigator_language='en';

  @ViewChild('linkedin_toggleElement') linkedin_toggleElement: IonToggle;
  @ViewChild('facebook_toggleElement') facebook_toggleElement: IonToggle;
  linkedin_user_name;
  linkedin_email_verification;
  linkedin_profile_photo;
  linkedin_email:boolean=false;


  @ViewChild('twitter_toggleElement') twitter_toggleElement: IonToggle;
  twitter_profile_photo;
  twitter_likes_count;
  twitter_is_verified;
  twitter_profile_deep_link;
  twitter_username;
  twitter_followers;
  twitter_following;
  twitter_content_count;
  twitter_privacy_level_options;
  twitter_profile_bio_description;

  @ViewChild('instagram_toggleElement') instagram_toggleElement: IonToggle;
  instagram_media_count;
  instagramReelsEnabled;
  instagramStoriesEnabled;
  instagram_follows;
  instagram_followers;
  instagram_biography;
  instagram_user_name;
  instagram_profile_photo;

  @ViewChild('TikTok_toggleElement') TikTok_toggleElement: IonToggle;
  tiktokDuetEnabled:boolean=false;
  tiktokStitchEnabled:boolean=false;
  tiktokVideoEnabled;
  tiktok_followers;
  tiktokPhotoEnabled;
  video_cover_timestamp_ms;
  tiktok_is_verified;
  tiktok_profile_bio_description;
  tiktok_profile_deep_link;
  tiktok_video_count;
  tiktok_likes_count;
  tiktok_following;
  tiktok_Content_Disclosure_Setting:boolean=false;
  tiktok_contenido_de_marca:boolean=false;
  tiktok_auto_add_music:boolean=false;
  tiktok_tu_marca:boolean=false;
  tiktok_privacy;
  tiktokDraftEnabled;
  tiktokDirectPost;
  tiktok_privacy_level_options;
  tiktok_profile_photo;
  tiktok_comment_disabled;
  tiktok_username;
  images_compatible_to_tiktok=[];
  private tikTokPhotoUrls = new Map<number, string>();
  private tikTokPhotoExpectedCount = 0;
  private tikTokPhotoPosting = false;
  thirdPrtyMedia:any;
  thirdPrtyMediaType;
  publication_id;
  public threadsEnabled:boolean=false;
  private checkingThreadsConnection = false;
  public tiktokEnabled:boolean=false;
  private checkingTikTokConnection = false;
public instagramEnabled:boolean=false;
public twitterEnabled:boolean=false;
private checkingXConnection = false;
public linkedinEnabled:boolean=false;
private checkingLinkedInConnection = false;
public youTubeEnabled:boolean=false;
public facebookEnabled:boolean=false;
private checkingFacebookConnection = false;
  facebook_account_id;
  facebook_user_name;
  facebook_profile_photo;
  facebook_email:boolean=false;
  facebook_email_verification;
  // Modulo Earth Multimedias
  Habitacion = "../../../../../assets/icon/Iconos/cuarto.png"
  Bathroom = "../../../../../assets/icon/Iconos/Bathroom.png"
  KingSize = "../../../../../assets/icon/Iconos/cama-king.png"
  QueenSize = "../../../../../assets/icon/Iconos/bed-queen.png"
  Matrimonial = "../../../../../assets/icon/Iconos/cama-matrimonial.png"
  Cama_agua = "../../../../../assets/icon/Iconos/colchon.png"
  Individual = "../../../../../assets/icon/Iconos/cama-individual.png"
  CamaNin = "../../../../../assets/icon/Iconos/cama-nino.png"
  Cuna = "../../../../../assets/icon/Iconos/cuna.png"
  Litera = "../../../../../assets/icon/Iconos/litera.png"
  Sofa = "../../../../../assets/icon/Iconos/sofa.png"
  Sofa_cama = "../../../../../assets/icon/Iconos/sofa-cama.png"
  Colchon_inflable = "../../../../../assets/icon/Iconos/colchon-de-aire.png"
  Colchon_suelo = "../../../../../assets/icon/Iconos/colchoneta-para-dormir.png"
  Hamaca = "../../../../../assets/icon/Iconos/hamaca.png"

  imagen: string = ""
  multimedias: Array<object> = []
  public multimedia: Array<MediaItem> = new Array<MediaItem>();
  multimedias_to_upload = [];





  @Input() ReservaCalendario: Array<any>;

  constructor(
    private request:RequestService,
    private cameraService: CameraServiceService,
    public publicationService: PublicationService,
    public navCtrl: NavController,
    public alertController: AlertController,
    public formservice: FormServiceService,
    public utils: Utils,
    public modalController: ModalController,
    public uploadmultimedia:UploadMultimediaService,
    public principal:PrincipalPublicationComponent,
    private myfeed:MyFeedPagePage,
    private googleAccountAuth: GoogleAccountAuthService,
    private socialAccountAuth: SocialAccountAuthService,
    private router: Router,
  ) { }
  ngOnInit() {
    this.captureCounterVisibilityBeforeDescription();
    this.publicationSummaryVisible = false;
    console.log("tipo de publicacion:",this.formservice.publication_type);
    if (this.formservice.publication_type=="lkfilm") {
      this.formservice.lkpublication.price=this.formservice.price

    }else if(this.formservice.publication_type=="normal"){
      this.formservice.normalpublication.price=this.formservice.price
    }

    console.log(this.formservice.normalpublication.title);
    console.log(this.formservice.publication_type);
    console.log("divisa ",this.formservice.divisa);
    console.log("ubicacion ",this.formservice.ubicacion);

    console.log("formservice media",this.formservice.multimedia);

    if (this.startInPreview) {
      setTimeout(() => this.continueToPublicationSummary(), 0);
    }
    this.formservice.multimedia.forEach(element => {
      this.imagen = Capacitor.convertFileSrc(element.mediaPath + element.nameFile);
      console.log("ruta media", this.imagen);
      const imagenes = {
        imagen: this.imagen
      };
      this.multimedias.push(imagenes);

    });

    this.CapturaReserva();
    this.CapturaReservaEarth();
    void this.requestAllSocialMediaAuthentications();
  }

  /**
   * Warm every social-account state when the publication flow opens. These are
   * read-only checks: an authenticated account is cached for its toggle, while
   * an unauthenticated account remains disabled until the user explicitly asks
   * to connect it.
   */
  private async requestAllSocialMediaAuthentications(): Promise<void> {
    const checks: Array<Promise<void>> = [
      this.requestSocialAuthentication('getAuthInstagramProfile', { corp: true }, data => {
        if (!data?.success || !data?.tp_user) return;
        const profile = data.tp_user;
        this.instagram_profile_photo = profile.profile_picture_url;
        this.instagram_user_name = profile.username;
        this.instagram_biography = profile.biography;
        this.instagram_followers = profile.followers_count;
        this.instagram_follows = profile.follows_count;
        this.instagram_media_count = profile.media_count;
      }),
      this.requestSocialAuthentication('getAuthTikTokProfile', {}, data => {
        const creator = data?.success?.data;
        if (!creator) return;
        const genuineUser = data?.genuine_data?.data?.user || {};
        this.tiktok_profile_photo = creator.creator_avatar_url;
        this.tiktok_username = creator.creator_username;
        this.tiktok_privacy_level_options = creator.privacy_level_options;
        this.tiktok_followers = genuineUser.follower_count;
        this.tiktok_following = genuineUser.following_count;
        this.tiktok_likes_count = genuineUser.likes_count;
        this.tiktok_video_count = genuineUser.video_count;
        this.tiktok_is_verified = genuineUser.is_verified;
        this.tiktok_profile_deep_link = genuineUser.profile_deep_link;
        this.tiktok_profile_bio_description = genuineUser.bio_description;
      }),
      this.requestSocialAuthentication('getAuthXProfile', {}, data => {
        if (!data?.success || !data?.tp_user) return;
        const profile = data.tp_user;
        this.twitter_profile_photo = profile.profile_image_url;
        this.twitter_username = profile.username;
        this.twitter_privacy_level_options = profile.protected;
        this.twitter_followers = profile.followers_count;
        this.twitter_following = profile.following_count;
        this.twitter_likes_count = profile.like_count;
        this.twitter_content_count = profile.tweet_count;
        this.twitter_is_verified = profile.verified;
        this.twitter_profile_deep_link = profile.url;
        this.twitter_profile_bio_description = profile.description;
      }),
      this.requestSocialAuthentication('getAuthFacebookProfile', {}, data => {
        if (!data?.success) return;
        const profile = typeof data.success === 'object' ? data.success : {};
        const tpUser = data.tp_user || {};
        this.facebook_account_id = profile.id || tpUser.id || tpUser.user_id || tpUser.account_id;
        this.facebook_profile_photo = profile.picture || tpUser.profile_image_url || tpUser.picture;
        this.facebook_user_name = profile.name || profile.username || tpUser.name || tpUser.username || this.facebook_account_id;
        this.facebook_email = profile.email || tpUser.email || null;
        this.facebook_email_verification = profile.email_verified || tpUser.email_verified;
      }),
      this.requestSocialAuthentication('getAuthLinkedInProfile', {}, data => {
        if (!data?.success || typeof data.success !== 'object') return;
        this.linkedin_profile_photo = data.success.picture;
        this.linkedin_user_name = data.success.name;
        this.linkedin_email = data.success.email;
        this.linkedin_email_verification = data.success.email_verified;
      }),
      this.requestSocialAuthentication('getAuthYouTubeToken', {}, data => {
        if (!data?.success) return;
        this.youtube_email = data.tp_username || data.email || data.success?.email;
      }),
      this.requestSocialAuthentication('redirectToThreadsLoginForEntanglement', { auth: true }, data => {
        if (data?.id) this.threads_id = data.id;
      }),
    ];

    await Promise.all(checks);
  }

  private async requestSocialAuthentication(
    endpoint: string,
    payload: any,
    applyAuthentication: (data: any) => void
  ): Promise<void> {
    try {
      const response = await this.request.createRequestPost(endpoint, payload);
      applyAuthentication(this.parseSocialAuthenticationResponse(response));
    } catch (error) {
      // Not being connected is valid on initialization. Login is only offered
      // later if the user explicitly enables that platform's toggle.
      console.debug(`No active ${endpoint} authentication found on init.`, error);
    }
  }

  private parseSocialAuthenticationResponse(response: any): any {
    if (typeof response !== 'string') return response || {};
    try {
      return JSON.parse(response);
    } catch {
      return {};
    }
  }

  continueToPublicationSummary(): void {
    this.captureCounterVisibilityBeforeDescription();
    this.formservice.showMoreHidden = false;
    // Prevent a nested publication template from applying its normal default
    // while the final composer preview is being initialized.
    this.formservice.showMorePreferenceChanged = true;
    this.publicationSummaryPreview = [this.buildPublicationSummaryPreview()];
    this.publicationSummaryVisible = true;
  }

  ngOnDestroy(): void {
    this.restoreCounterVisibilityAfterPublication();
  }

  private captureCounterVisibilityBeforeDescription(): void {
    if (this.showMoreHiddenBeforePublicationSummary === null) {
      this.showMoreHiddenBeforePublicationSummary = this.formservice.showMoreHidden;
    }
    if (this.showMorePreferenceChangedBeforePublicationSummary === null) {
      this.showMorePreferenceChangedBeforePublicationSummary = this.formservice.showMorePreferenceChanged;
    }
  }

  private restoreCounterVisibilityAfterPublication(): void {
    if (this.showMoreHiddenBeforePublicationSummary === null) return;

    this.formservice.showMoreHidden = this.showMoreHiddenBeforePublicationSummary;
    if (this.showMorePreferenceChangedBeforePublicationSummary !== null) {
      this.formservice.showMorePreferenceChanged = this.showMorePreferenceChangedBeforePublicationSummary;
    }
    this.showMoreHiddenBeforePublicationSummary = null;
    this.showMorePreferenceChangedBeforePublicationSummary = null;
  }

  private buildPublicationSummaryPreview(): any {
    const blobMedia = (this.formservice.normalpublication?.blobsMultimedia || [])
      .map((item: any) => {
        const filename = String(item?.filename || '');
        const remoteUrl = item?.remoteUrl || item?.blob?.remoteUrl;
        const remoteMimeType = item?.mimeType || item?.blob?.mimeType;
        if (remoteUrl) {
          return {
            url: remoteUrl,
            type: String(remoteMimeType || '').startsWith('video/') || this.isVideo(filename || remoteUrl)
              ? 'Video'
              : 'Imagen',
          };
        }
        if (item?.blob instanceof Blob) {
          return {
            url: URL.createObjectURL(item.blob),
            type: item.blob.type?.startsWith('video/') || this.isVideo(filename) ? 'Video' : 'Imagen',
          };
        }
        if (typeof item?.blob === 'string') {
          return {
            url: Capacitor.convertFileSrc(`${item.blob}${filename}`),
            type: this.isVideo(filename || item.blob) ? 'Video' : 'Imagen',
          };
        }
        return null;
      });
    const serviceMedia = (this.formservice.multimedia || []).map((item: any) => {
      const url = item?.image || item?.url || item?.localUrl || item?.route
        || (item?.mediaPath ? Capacitor.convertFileSrc(`${item.mediaPath}${item?.nameFile || ''}`) : null);
      const mediaType = String(item?.type || item?.typeData || '');
      return url ? {
        url,
        type: mediaType === 'Video' || mediaType.startsWith('video/') || this.isVideo(item?.nameFile || url)
          ? 'Video'
          : 'Imagen',
      } : null;
    });
    const mediaCandidates = [
      this.formservice.Capacitor_convertFileSrc_video
        ? { url: this.formservice.Capacitor_convertFileSrc_video, type: 'Video' }
        : null,
      this.formservice.Capacitor_convertFileSrc
        ? { url: this.formservice.Capacitor_convertFileSrc, type: 'Imagen' }
        : null,
      ...serviceMedia,
      ...blobMedia,
    ].filter((item: any) => Boolean(item?.url));
    const seenMediaUrls = new Set<string>();
    const previewMedia = mediaCandidates.filter((item: any) => {
      if (seenMediaUrls.has(item.url)) return false;
      seenMediaUrls.add(item.url);
      return true;
    });
    const profile = this.formservice.profile || {};
    const rawProfilePhoto = profile.profile_photo;
    const profilePhoto = typeof rawProfilePhoto === 'string'
      ? rawProfilePhoto
      : rawProfilePhoto?.url || rawProfilePhoto?.route || rawProfilePhoto?.localUrl || 'assets/icon/usuario.png';

    return {
      id: null,
      title: this.formservice.title || this.formservice.normalpublication?.title || 'Vista previa de publicación',
      description: this.formservice.description || this.formservice.normalpublication?.description || '',
      price: this.publicationSummaryPrice || 0,
      divisa: this.formservice.divisa,
      ubicacion: this.formservice.ubicacion,
      publication_type: this.formservice.publication_type || 'normal',
      multimediaContainer: previewMedia.map((media: any, index: number) => ({
        id: index + 1,
        index,
        url: media.url,
        route: media.url,
        type: media.type,
        is_premium: 0,
      })),
      userProfile: {
        user_id: profile.id || null,
        username: profile.username || profile.name || 'Laniakea',
        profile_photo: profilePhoto,
      },
      owner: true,
      corp: false,
      Verified: profile.kyc === 'Validado',
      // Match the relationship envelope returned by the publications API.
      // The shared header reads Relative.followButton.text even for an owner
      // preview, so a boolean here aborts rendering of the complete template.
      Relative: {
        followButton: {
          text: 'Siguiendo',
          error: false,
          relation_id: null,
        },
      },
      createdAt: new Date().toISOString(),
      reactionCounter: 0,
      commentCounter: 0,
      SharedCounter: 0,
      SaveCounter: 0,
      regalos: 0,
      views: 0,
      ownReaction: null,
      is_saved: false,
    };
  }

  get publicationSummaryPrice(): any {
    const typedPublication = ({
      normal: this.formservice.normalpublication,
      lkfilm: this.formservice.lkpublication,
      earth: this.formservice.earthpublication,
      epoch: this.formservice.epochpublication,
      eventos: this.formservice.eventospublication,
      land: this.formservice.landpublication,
      feex: this.formservice.feexpublication,
    } as Record<string, any>)[this.formservice.publication_type];

    return typedPublication?.price ?? typedPublication?.additional_price ?? this.formservice.price;
  }
  public isVideo(url:string) {
    Capacitor.convertFileSrc(url);
    return isVideo(url);
  }
  ngAfterViewInit(){
    const imagePreviewElement = document.getElementById("imagePreview") as HTMLImageElement;
    if (this.formservice.Capacitor_convertFileSrc && imagePreviewElement){
    setTimeout(() => {
      if (this.formservice.Capacitor_convertFileSrc){
        imagePreviewElement.src =this.formservice.Capacitor_convertFileSrc;
      }

  }, 999);
}
const videoPreviewElement = document.getElementById("videoSource") as HTMLVideoElement;
if (videoPreviewElement) {
  videoPreviewElement.muted = true;
  videoPreviewElement.defaultMuted = true;
}
if (this.formservice.Capacitor_convertFileSrc_video && videoPreviewElement){
setTimeout(() => {
  if (this.formservice.Capacitor_convertFileSrc_video){
    videoPreviewElement.src =this.formservice.Capacitor_convertFileSrc_video;
  }

}, 999);
}
  }

  public isImage(url:string){
    Capacitor.convertFileSrc(url);
    return isImage(url);
  }

  CapturaReserva() {


    let Reservas = this.formservice.landpublication.ReservaCalendario;

    // console.log('Reserva en descripcion:', Reservas);

    const Agenda: Array<object> = [];

    Agenda.push(Reservas);

    // console.log('Agenda:', Agenda);

    Agenda.forEach((element) => {
      let key = Object.keys(element);
      let valor = Object.values(element);

      valor = valor.map((obj, idx) => ({
        fecha: key[idx],
        cupo: obj.cupo,
        horas: obj.hora,
      })


      );

      this.formservice.landpublication.ReservaCalendario = valor
      // console.log("nuevo valor ReservaC:", this.formservice.landpublication.ReservaCalendario);


      // console.log("Latitud:", this.formservice.landpublication.latitud, "Longitud", this.formservice.landpublication.longitud);


    });


  }
  CapturaReservaEarth() {


    let Reservas = this.formservice.earthpublication.ReservaCalendario;

    // console.log('Reserva en descripcion:', Reservas);

    const Agenda: Array<object> = [];

    Agenda.push(Reservas);

    // console.log('Agenda:', Agenda);

    Agenda.forEach((element) => {
      let key = Object.keys(element);
      let valor = Object.values(element);

      valor = valor.map((obj, idx) => ({
        fecha: key[idx],
        cupo: obj.cupo,
        horas: obj.hora,
      })


      );

      this.formservice.earthpublication.ReservaCalendario = valor
      // console.log("nuevo valor ReservaC:", this.formservice.landpublication.ReservaCalendario);


      // console.log("Latitud:", this.formservice.landpublication.latitud, "Longitud", this.formservice.landpublication.longitud);


    });


  }

  dismissNormal() {
    this.restoreCounterVisibilityAfterPublication();
    this.formservice.title = '';
    this.formservice.description = '';
    this.formservice.is_feed = false;
    this.formservice.quienpuedever = 'Para todos';
    this.formservice.price = 0;
    this.modalController.dismiss({
      dismissed: true,
    });
    this.thirdPrtyMedia=null;
  }

  /** A successful normal post opens the author's Posts section on their profile. */
  private async finishNormalPublication(publicationId?: number): Promise<void> {
    this.restoreCounterVisibilityAfterPublication();
    // Third-party requests (X, Wix, Meta, etc.) continue after local media
    // upload. Do not mutate their shared composer state here: the former
    // cleanup raced those requests and could erase their caption/title.
    // This intentionally mirrors the original `back()` behavior.

    const topModal = await this.modalController.getTop();
    if (topModal) {
      await topModal.dismiss({ dismissed: true });
    }

    await this.router.navigate(['/home/profile'], {
      replaceUrl: true,
      queryParams: {
        section: 'Posts',
        focusPublicationId: Number.isSafeInteger(publicationId) ? publicationId : null,
      },
    });
  }

  dismissLk() {
    this.restoreCounterVisibilityAfterPublication();
    this.formservice.title = '';
    this.formservice.description = '';
    this.formservice.is_feed = false;
    this.formservice.quienpuedever = 'Para todos';
    this.formservice.lkpublication.category = undefined;
    this.formservice.lkpublication.price = 0;
    this.modalController.dismiss({
      dismissed: true,
    });
    this.thirdPrtyMedia=null;
  }

  dismissEpoch() {
    this.restoreCounterVisibilityAfterPublication();
    this.formservice.title = '';
    this.formservice.description = '';
    this.formservice.is_feed = false;
    this.formservice.quienpuedever = 'Para todos';
    this.formservice.epochpublication.category = undefined;
    this.formservice.epochpublication.titleLeccion = undefined;
    this.formservice.epochpublication.descriptionLeccion = undefined;
    this.formservice.epochpublication.price = undefined;
    this.modalController.dismiss({
      dismissed: true,
    });
    this.thirdPrtyMedia=null;
  }

  dismissLand() {
    this.restoreCounterVisibilityAfterPublication();
    this.formservice.title = '';
    this.formservice.description = '';
    this.formservice.is_feed = false;
    this.formservice.quienpuedever = 'Para todos';
    this.formservice.landpublication.price = 0;
    this.formservice.landpublication.cantidad = undefined;
    this.formservice.landpublication.category = undefined;
    this.formservice.landpublication.service = undefined;
    this.formservice.landpublication.type_of_service = undefined;
    this.formservice.landpublication.agenda = undefined;
    this.formservice.landpublication.ubicacion = undefined;
    this.formservice.landpublication.zonaHoraria = undefined;
    this.formservice.landpublication.capacidad = undefined;
    this.formservice.landpublication.title2 = '';
    this.formservice.landpublication.description2 = '';
    this.formservice.landpublication.price2 = 0;
    this.formservice.landpublication.fecha_inicial = undefined;
    this.formservice.landpublication.fecha_final = undefined;
    this.formservice.landpublication.hora_inicial = undefined;
    this.formservice.landpublication.hora_final = undefined;
    this.modalController.dismiss({
      dismissed: true,
    });
    this.thirdPrtyMedia=null;
  }

  dismissEarth() {
    this.restoreCounterVisibilityAfterPublication();
    this.formservice.title = '';
    this.formservice.description = '';
    this.formservice.is_feed = false;
    this.formservice.quienpuedever = 'Para todos';
    this.formservice.earthpublication.price = undefined;
    this.formservice.earthpublication.lugar = undefined;
    this.formservice.earthpublication.tipo = undefined;
    this.formservice.earthpublication.alojamiento = undefined;
    this.formservice.earthpublication.alojamientoExclusivo = undefined;
    this.formservice.earthpublication.capacidad = undefined;
    this.formservice.earthpublication.bedrooms = 0;
    this.formservice.earthpublication.bathroom = 0;
    this.formservice.earthpublication.king_bed = 0;
    this.formservice.earthpublication.queen_bed = 0;
    this.formservice.earthpublication.matrimonial_bed = 0;
    this.formservice.earthpublication.individual_bed = 0;
    this.formservice.earthpublication.sofa_bed = 0;
    this.formservice.earthpublication.sofa = 0;
    this.formservice.earthpublication.inflatable_mattress = 0;
    this.formservice.earthpublication.litera = 0;
    this.formservice.earthpublication.mattress_on_the_floor = 0;
    this.formservice.earthpublication.bed_for_children = 0;
    this.formservice.earthpublication.crib = 0;
    this.formservice.earthpublication.water_bed = 0;
    this.formservice.earthpublication.hamaca = 0;
    this.formservice.earthpublication.direction = undefined;
    this.formservice.earthpublication.interior_number = undefined;
    this.formservice.earthpublication.exterior_number = undefined;
    this.formservice.earthpublication.postal_code = undefined;
    this.formservice.earthpublication.col = undefined;
    this.formservice.earthpublication.city = undefined;
    this.formservice.earthpublication.state = undefined;
    this.formservice.earthpublication.wifi = 'No';
    this.formservice.earthpublication.kitchen_room = 'No';
    this.formservice.earthpublication.free_parking = 'No';
    this.formservice.earthpublication.tv = 'No';
    this.formservice.earthpublication.air_conditioning = 'No';
    this.formservice.earthpublication.washing_machine = 'No';
    this.formservice.earthpublication.drying_machine = 'No';
    this.formservice.earthpublication.iron = 'No';
    this.formservice.earthpublication.swimming_pool = 'No';
    this.formservice.earthpublication.pets = 'No';
    this.formservice.earthpublication.smoking_is_allowed = 'No';
    this.formservice.earthpublication.events_are_allowed = 'No';
    this.formservice.earthpublication.personal_clean = 'No';
    this.formservice.earthpublication.additional_details = undefined;
    this.formservice.earthpublication.fecha_inicial = undefined;
    this.formservice.earthpublication.fecha_final = undefined;
    this.modalController.dismiss({
      dismissed: true,
    });
    this.thirdPrtyMedia=null;
  }

  dismissEventos() {
    this.restoreCounterVisibilityAfterPublication();
    this.formservice.title = '';
    this.formservice.description = '';
    this.formservice.is_feed = false;
    this.formservice.quienpuedever = 'Para todos';
    this.formservice.eventospublication.category = undefined;
    this.formservice.eventospublication.link = undefined;
    this.formservice.eventospublication.limited_availability = undefined;
    this.formservice.eventospublication.ubicacion = undefined;
    this.formservice.eventospublication.street = undefined;
    this.formservice.eventospublication.interior_number = undefined;
    this.formservice.eventospublication.exterior_number = undefined;
    this.formservice.eventospublication.postal_code = undefined;
    this.formservice.eventospublication.col = undefined;
    this.formservice.eventospublication.city = undefined;
    this.formservice.eventospublication.state = undefined;
    this.formservice.eventospublication.fecha_inicial = undefined;
    this.formservice.eventospublication.fecha_final = undefined;
    this.formservice.eventospublication.hora_inicial = undefined;
    this.formservice.eventospublication.hora_final = undefined;
    this.modalController.dismiss({
      dismissed: true,
    });
    this.thirdPrtyMedia=null;
  }

  publicUpdatemultimedia( multimedia:Array<MediaItem>, type: string, size: number, publication_ids:Array<number>,id:number) {
    this.cameraService
      .postArrayMultimedia(
        multimedia,
        publication_ids,
        'publications.multimedia/' + id,
        this.formservice.publication_type
      )
      .then((ruta: any) => {
        this.updateStatusPublication(publication_ids)
          .then(() => {
            this.publicationService
              .getPublicationByID(publication_ids[0], true)
              .then((publication) => {
                // De ser una historia la publicacion recien creada se debe agregar o reemplazar la historia actual
                console.log("Publicacion normal", publication);
                if (publication.publication_type == 'story') {
                  this.publicationService.updatePublicationList(
                    'MyStoriesList',
                    publication,
                    true
                  );
                } else {
                  //createpost request
                  let pub_type = '';
                  // console.log(this.multimedias[0].typeData);
                  console.log("multimedias:", this.multimedias);
                    if(type.includes("image")) {
                      pub_type= 'imagen';
                    }else if(type.includes("video")){
                      pub_type= 'video';
                    }
                    const objmedia = {
                      route: ruta[0].route,
                      size: size,
                      type:pub_type,
                      publication_type: publication.publication_type,
                      publication_id:id

                    };
                    console.log('objmedia', objmedia);
                    this.request.createRequestPost('publications.multimedia',objmedia).then((final_data) => {

                      this.utils.loadingDismiss();

                    }).catch((error) => {

                      this.utils.loadingDismiss();
                      Swal2.fire({
                        title: 'Error al subir multimedia!',
                        text: error,
                        icon: 'warning',
                        confirmButtonText: 'Understood',
                        color: '#ffffff',
                        background: '#010f4e',
                        position: 'top-end',
                        timerProgressBar: true,
                        toast: true,
                      });
                    });

                }
              })
              .catch((error) => {
                console.error(error);
              });
          })
          .catch((error) => {
            console.error(error);
          });
        //this.publicationService.updatePublicationList('MyFeedList', data, true);
        //this.publicationService.updatePublicationList('MyPublicationsList', data, true);
      });
  }

  async back() {
    this.restoreCounterVisibilityAfterPublication();
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss({
        dismissed: true
      });
      return;
    }
    this.navCtrl.back();
  }
  postToIG(mediaUrl: string = this.thirdPrtyMedia, mediaType: string = this.thirdPrtyMediaType){
    if (!this.instagramEnabled) return;

    // A photo enabled for Instagram is always published to the profile grid.
    // Stories and Reels are additional destinations and require independent
    // Meta media containers.
    const destinations: InstagramDestination[] = [];
    if (mediaType === 'imagen') destinations.push('FEED');
    if (this.instagramStoriesEnabled) destinations.push('STORIES');
    if (this.instagramReelsEnabled && mediaType === 'video') destinations.push('REELS');

    destinations.forEach(destination => this.postToInstagramDestination(destination, mediaUrl, mediaType));
  }

  private async postToInstagramDestination(destination: InstagramDestination, mediaUrl: string, mediaType: string): Promise<void> {
    let instagramMediaUrl = mediaUrl;
    this.setThirdPartyPublishStatus(
      'processing',
      destination === 'STORIES' && mediaType === 'video'
        ? 'Preparing your Instagram Story locally…'
        : `Sending your publication to Instagram ${destination}…`,
    );

    if (destination === 'STORIES' && mediaType === 'video') {
      try {
        instagramMediaUrl = await this.prepareInstagramStoryVideo(mediaUrl);
      } catch (error) {
        console.error('Local Instagram Story video preparation failed:', error);
        this.showInstagramPublishError(destination, error);
        return;
      }
    }

    const payload = {
      instagramDestination: destination,
      // Only a long Story is rendered and watermarked in this browser. Reels
      // and feed media must always remain unwatermarked.
      localWatermarkApplied: destination === 'STORIES' && instagramMediaUrl !== mediaUrl,
      watermarkPolicy: destination === 'STORIES' && instagramMediaUrl !== mediaUrl ? 'local' : 'none',
      // Social endpoints only publish the supplied URL. They must never start
      // a PHP watermark job for a Story, Reel, or feed post.
      skipServerWatermark: true,
      // Keep the legacy fields for a backend that has not yet been deployed,
      // but make them mutually exclusive so it can never choose the wrong one.
      instagramReelsEnabled: destination === 'REELS',
      instagramStoriesEnabled: destination === 'STORIES',
      mediaUrl: instagramMediaUrl,
      caption: this.getThirdPartyPublicationDescription(),
      mediaType
    };

    this.request.createRequestPost('postToInstagram', payload).then((response: any) => {
      const data = this.parseInstagramResponse(response);
      if (mediaType === 'video' && data?.mediaId) {
        this.setThirdPartyPublishStatus('processing', `Instagram ${destination} received the video. Preparing it…`);
        this.pollInstagramVideo(data.mediaId, destination);
        return;
      }
      if (data?.success) {
        this.showInstagramSuccess(destination);
        return;
      }
      this.showInstagramPublishError(destination, data);
    }).catch(error => {
      console.error(`Instagram ${destination} creation failed:`, error);
      this.showInstagramPublishError(destination, error);
    });
  }

  /**
   * Instagram Stories accepts a short video only. Trim long remote videos in
   * the browser with MediaRecorder, upload the resulting MP4 directly to S3,
   * and give Instagram the new short public URL. The original video is never
   * downloaded or processed by the API server.
   */
  private prepareInstagramStoryVideo(mediaUrl: string): Promise<string> {
    const cached = this.instagramStoryVideoPromises.get(mediaUrl);
    if (cached) return cached;

    const preparation = this.trimAndUploadInstagramStoryVideo(mediaUrl);
    this.instagramStoryVideoPromises.set(mediaUrl, preparation);
    return preparation;
  }

  private async trimAndUploadInstagramStoryVideo(mediaUrl: string): Promise<string> {
    const sourceResponse = await fetch(this.corsReadableVideoUrl(mediaUrl));
    if (!sourceResponse.ok) {
      throw new Error(`No se pudo descargar el video para Stories (${sourceResponse.status}).`);
    }

    const sourceBlob = await sourceResponse.blob();
    const sourceObjectUrl = URL.createObjectURL(sourceBlob);
    const video: any = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;
    video.src = sourceObjectUrl;

    const waitFor = (eventName: string, timeoutMs = 15000): Promise<void> =>
      new Promise((resolve, reject) => {
        let settled = false;
        const cleanup = () => {
          video.removeEventListener(eventName, onEvent);
          video.removeEventListener('error', onError);
          clearTimeout(timeout);
        };
        const finish = (error?: Error) => {
          if (settled) return;
          settled = true;
          cleanup();
          error ? reject(error) : resolve();
        };
        const onEvent = () => finish();
        const onError = () => finish(new Error('El navegador no pudo decodificar el video.'));
        const timeout = setTimeout(() => finish(new Error('La preparación local del video agotó el tiempo.')), timeoutMs);
        video.addEventListener(eventName, onEvent, { once: true });
        video.addEventListener('error', onError, { once: true });
      });

    try {
      await waitFor('loadedmetadata');
      const duration = Number(video.duration);
      if (!Number.isFinite(duration) || duration <= 0) {
        throw new Error('No se pudo determinar la duración del video.');
      }

      // A compliant source does not need a second upload.
      if (duration <= this.instagramStoryMaxDurationSeconds) return mediaUrl;

      const captureStream = video.captureStream || video.webkitCaptureStream;
      const MediaRecorderConstructor = (window as any).MediaRecorder;
      if (!captureStream || !MediaRecorderConstructor) {
        throw new Error('Este navegador no permite recortar videos localmente para Instagram Stories.');
      }

      const supportedMimeTypes = [
        'video/mp4;codecs="avc1.42E01E,mp4a.40.2"',
        'video/mp4',
      ];
      const mimeType = supportedMimeTypes.find(type =>
        MediaRecorderConstructor.isTypeSupported?.(type)
      );
      if (!mimeType) {
        throw new Error('Este navegador no puede generar MP4 localmente; Instagram Stories requiere MP4.');
      }

      const logo = await this.loadWatermarkLogo();
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');
      if (!context || canvas.width < 1 || canvas.height < 1) {
        throw new Error('No se pudo preparar el lienzo de la historia.');
      }

      const sourceStream = captureStream.call(video);
      const outputStream = canvas.captureStream(30);
      sourceStream.getAudioTracks().forEach((track: MediaStreamTrack) => outputStream.addTrack(track));
      const chunks: Blob[] = [];
      const recorder = new MediaRecorderConstructor(outputStream, { mimeType });
      const recordingFinished = new Promise<Blob>((resolve, reject) => {
        recorder.ondataavailable = (event: any) => {
          if (event.data?.size) chunks.push(event.data);
        };
        recorder.onerror = () => reject(new Error('La grabación local del video falló.'));
        recorder.onstop = () => resolve(new Blob(chunks, { type: 'video/mp4' }));
      });

      recorder.start(1000); // Emit small local chunks while recording.
      const draw = () => {
        if (!video.paused && !video.ended) {
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
          this.drawMovingWatermark(context, logo, canvas.width, canvas.height, video.currentTime);
          requestAnimationFrame(draw);
        }
      };
      video.currentTime = 0;
      await video.play();
      draw();
      await new Promise(resolve => setTimeout(resolve, this.instagramStoryMaxDurationSeconds * 1000));
      recorder.stop();
      const trimmedBlob = await recordingFinished;
      if (!trimmedBlob.size) throw new Error('El video recortado quedó vacío.');

      // uploadFile derives the extension from the Blob MIME type; passing an
      // extension here produced names such as `.mp4.mp4`.
      const filename = `instagram-story-${Date.now()}`;
      const uploaded = await this.uploadmultimedia.uploadFile(trimmedBlob, filename);
      return uploaded.link;
    } finally {
      try { video.pause(); } catch { /* noop */ }
      video.removeAttribute('src');
      try { video.load(); } catch { /* noop */ }
      URL.revokeObjectURL(sourceObjectUrl);
    }
  }

  private corsReadableVideoUrl(mediaUrl: string): string {
    try {
      const url = new URL(mediaUrl, window.location.href);
      if (!url.searchParams.has('X-Amz-Signature')) {
        url.searchParams.set('laniakea-local-render', String(Date.now()));
      }
      return url.toString();
    } catch {
      return mediaUrl;
    }
  }

  private loadWatermarkLogo(): Promise<HTMLImageElement> {
    if (!this.watermarkLogoPromise) {
      this.watermarkLogoPromise = new Promise((resolve, reject) => {
        const logo = new Image();
        logo.crossOrigin = 'anonymous';
        logo.onload = () => resolve(logo);
        logo.onerror = () => reject(new Error('No se pudo cargar la marca de agua.'));
        logo.src = 'https://laniakea-multimedia.s3.us-east-1.amazonaws.com/laniakea.tv/Frame+54+Background+Removed.png';
      });
    }
    return this.watermarkLogoPromise;
  }

  private drawMovingWatermark(context: CanvasRenderingContext2D, logo: HTMLImageElement, width: number, height: number, time: number): void {
    const watermarkWidth = Math.max(64, Math.round(width * 0.14));
    const watermarkHeight = Math.round(watermarkWidth * (logo.naturalHeight / logo.naturalWidth));
    const margin = Math.max(16, Math.round(width * 0.025));
    const corners = [
      { x: margin, y: margin },
      { x: width - watermarkWidth - margin, y: margin },
      { x: width - watermarkWidth - margin, y: height - watermarkHeight - margin },
      { x: margin, y: height - watermarkHeight - margin },
    ];
    const corner = corners[Math.floor(Math.max(0, time) / 3) % corners.length];
    context.globalAlpha = 0.9;
    context.drawImage(logo, corner.x, corner.y, watermarkWidth, watermarkHeight);
    context.globalAlpha = 1;
  }

  private showInstagramPublishError(destination: InstagramDestination, error: any): void {
    const responseBody = error?.error ?? error;
    const nestedError = responseBody?.error;
    const message = String(
      nestedError?.message
      || (typeof nestedError === 'string' ? nestedError : null)
      || responseBody?.message
      || error?.message
      || 'Instagram rechazó el contenido.'
    );
    this.setThirdPartyPublishStatus('error', `Instagram ${destination}: ${message}`, 7000);
  }

  private pollInstagramVideo(mediaId: string, destination: InstagramDestination): void {
    this.request.createRequestPost('postToInstagram', {
      mediaType: 'video',
      mediaId,
      instagramDestination: destination
    }).then((response: any) => {
      const data = this.parseInstagramResponse(response);
      if (data?.success) {
        this.showInstagramSuccess(destination);
        return;
      }

      this.setThirdPartyPublishStatus(
        'processing',
        destination === 'STORIES'
          ? 'Instagram is preparing your Story. Checking again automatically…'
          : 'Instagram is preparing your Reel. Checking again automatically…',
      );
      setTimeout(() => this.pollInstagramVideo(mediaId, destination), 18000);
    }).catch(error => {
      console.error(`Instagram ${destination} status check failed:`, error);
      this.showInstagramPublishError(destination, error);
    });
  }

  private parseInstagramResponse(response: any): any {
    if (typeof response !== 'string') return response || {};
    try {
      return JSON.parse(response);
    } catch (error) {
      console.error('Error parsing Instagram response:', error);
      return {};
    }
  }

  private showInstagramSuccess(destination: InstagramDestination): void {
    this.setThirdPartyPublishStatus(
      'success',
      destination === 'STORIES'
        ? 'Your Instagram Story is live.'
        : destination === 'REELS'
          ? 'Your Instagram Reel is live.'
          : 'Your Instagram post is live.',
      5000,
    );
  }
  async postToX(xMediaId?: string){
    if (this.twitterEnabled){
      let mediaUrl = this.thirdPrtyMedia;
      if (!xMediaId && this.thirdPrtyMediaType === 'video') {
        this.setThirdPartyPublishStatus('processing', 'Preparing your video for 𝕏 locally…');
        try {
          mediaUrl = await this.prepareXVideo(mediaUrl);
        } catch (error) {
          console.error('Local X video preparation failed:', error);
          this.setThirdPartyPublishStatus('error', `𝕏: ${(error as any)?.message || 'The video could not be prepared.'}`, 7000);
          return;
        }
      }

      this.setThirdPartyPublishStatus('processing', xMediaId ? '𝕏 is finalizing your video…' : 'Sending your publication to 𝕏…');

      const payload: any = xMediaId
        ? { xMediaId, description: (this.formservice.description || '').slice(0, 270) }
        : {
          mediaUrl,
          description: (this.formservice.description || '').slice(0, 270),
          mediaType: this.thirdPrtyMediaType,
          // The X compatibility derivative is rendered locally with the
          // moving watermark. PHP must upload this exact file to X, never
          // create or request a second server-side watermark.
          localWatermarkApplied: this.thirdPrtyMediaType === 'video',
          skipServerWatermark: this.thirdPrtyMediaType === 'video',
        };

      this.request.createRequestPost('postMediaToX', payload)
		.then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
		// Open the login URL in the system browser
	
        console.log(data);
        if (data?.processing && data?.mediaId) {
          // X can make a large uploaded video addressable before its post API
          // can attach it. Poll with the returned media id; never upload again.
          window.setTimeout(() => this.postToX(data.mediaId), 4000);
          return;
        }

    if(data.success) this.setThirdPartyPublishStatus('success', 'Your publication is live on 𝕏.', 5000);
    else this.setThirdPartyPublishStatus('error', `𝕏: ${data?.message || data?.error || 'The publication was rejected.'}`, 7000);

    }).catch((error) => {
      console.error('Error posting to X:', error);
      this.setThirdPartyPublishStatus('error', `𝕏: ${error?.message || 'The publication could not be sent.'}`, 7000);
    });
    }
  }

  /**
   * X receives a browser-normalized MP4 rather than the original screen
   * recording.  The supplied MOV can be very high bitrate and wider than
   * common X playback dimensions even when it is only a few seconds long.
   * Scale locally, preserve audio, and upload the resulting object to S3.
   */
  private prepareXVideo(mediaUrl: string): Promise<string> {
    const cached = this.xVideoPromises.get(mediaUrl);
    if (cached) return cached;
    const preparation = this.normalizeXVideo(mediaUrl);
    this.xVideoPromises.set(mediaUrl, preparation);
    return preparation;
  }

  private async normalizeXVideo(mediaUrl: string): Promise<string> {
    const sourceResponse = await fetch(this.corsReadableVideoUrl(mediaUrl));
    if (!sourceResponse.ok) throw new Error(`No se pudo descargar el video (${sourceResponse.status}).`);
    const sourceObjectUrl = URL.createObjectURL(await sourceResponse.blob());
    const video: any = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;
    video.src = sourceObjectUrl;

    const waitForMetadata = new Promise<void>((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('No se pudo leer el video para X.')), 20000);
      video.onloadedmetadata = () => { clearTimeout(timeout); resolve(); };
      video.onerror = () => { clearTimeout(timeout); reject(new Error('El navegador no pudo decodificar el video.')); };
    });

    try {
      await waitForMetadata;
      const duration = Number(video.duration);
      const sourceStream = (video.captureStream || video.webkitCaptureStream)?.call(video);
      const MediaRecorderConstructor = (window as any).MediaRecorder;
      if (!sourceStream || !MediaRecorderConstructor) throw new Error('Este navegador no permite preparar el video localmente.');

      const maxWidth = 1920;
      const scale = Math.min(1, maxWidth / video.videoWidth);
      const canvas: HTMLCanvasElement = document.createElement('canvas');
      canvas.width = Math.max(2, Math.round(video.videoWidth * scale / 2) * 2);
      canvas.height = Math.max(2, Math.round(video.videoHeight * scale / 2) * 2);
      const context = canvas.getContext('2d');
      if (!context) throw new Error('No se pudo preparar el lienzo del video.');

      const canvasStream = canvas.captureStream(30);
      sourceStream.getAudioTracks().forEach((track: MediaStreamTrack) => canvasStream.addTrack(track));
      const logo = await this.loadWatermarkLogo();
      const mimeType = [
        'video/mp4;codecs="avc1.42E01E,mp4a.40.2"',
        'video/mp4',
      ].find(type => MediaRecorderConstructor.isTypeSupported?.(type));
      if (!mimeType) throw new Error('Este navegador no puede generar MP4 para X.');

      const chunks: Blob[] = [];
      const recorder = new MediaRecorderConstructor(canvasStream, {
        mimeType,
        videoBitsPerSecond: 8000000,
        audioBitsPerSecond: 128000,
      });
      const finished = new Promise<Blob>((resolve, reject) => {
        recorder.ondataavailable = (event: any) => event.data?.size && chunks.push(event.data);
        recorder.onerror = () => reject(new Error('La conversión local del video falló.'));
        recorder.onstop = () => resolve(new Blob(chunks, { type: 'video/mp4' }));
      });

      const draw = () => {
        if (!video.paused && !video.ended) {
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
          this.drawMovingWatermark(context, logo, canvas.width, canvas.height, video.currentTime);
          requestAnimationFrame(draw);
        }
      };
      recorder.start(1000);
      video.currentTime = 0;
      await video.play();
      draw();
      await new Promise<void>(resolve => {
        video.onended = () => resolve();
        setTimeout(resolve, Math.max(1000, (duration + 1) * 1000));
      });
      if (recorder.state !== 'inactive') recorder.stop();
      const normalized = await finished;
      if (!normalized.size) throw new Error('El video normalizado quedó vacío.');
      const uploaded = await this.uploadmultimedia.uploadFile(normalized, `x-video-${Date.now()}`);
      return uploaded.link;
    } finally {
      try { video.pause(); } catch { /* noop */ }
      video.removeAttribute('src');
      try { video.load(); } catch { /* noop */ }
      URL.revokeObjectURL(sourceObjectUrl);
    }
  }
  postToLinkedIn(){
    if (this.linkedinEnabled){
      this.setThirdPartyPublishStatus('processing', 'Sending your publication to LinkedIn…');
      const url = `https://laniakea.tv/p/${this.publication_id}`;
      this.request.createRequestPost('postMediaToLinkedIn', {mediaUrl:this.thirdPrtyMedia, caption:this.buildLinkedInCaption(url), mediaType: this.thirdPrtyMediaType })
		.then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
		// Open the login URL in the system browser
	
		console.log(data);
    if(data.success){
      this.setThirdPartyPublishStatus('success', 'Your publication is live on LinkedIn.', 5000);
    }else{
      const linkedInError = data.linkedin_error?.message || data.linkedin_error?.error_description || data.error || 'LinkedIn rejected the publication';
      this.setThirdPartyPublishStatus('error', `LinkedIn: ${linkedInError}`, 7000);
    }

	}).catch((error) => {
      const linkedInError = error?.error?.linkedin_error?.message || error?.error?.error || error?.message || 'LinkedIn rejected the publication';
      this.setThirdPartyPublishStatus('error', `LinkedIn: ${linkedInError}`, 7000);
  });
    }
  }
  postToFacebook(){
    if (this.facebookEnabled){
      this.setThirdPartyPublishStatus('processing', 'Sending your publication to Facebook…');
      const url = `https://laniakea.tv/p/${this.publication_id}`;
      this.request.createRequestPost('postMediaToFacebook', {mediaUrl:this.thirdPrtyMedia, caption:this.buildFacebookCaption(url), mediaType: this.thirdPrtyMediaType })
		.then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
		console.log(data);
    if(data.success) this.setThirdPartyPublishStatus('success', 'Your publication is live on Facebook.', 5000);
    else this.setThirdPartyPublishStatus('error', `Facebook: ${data?.message || data?.error || 'The publication was rejected.'}`, 7000);

	}).catch(error => this.setThirdPartyPublishStatus('error', `Facebook: ${error?.message || 'The publication could not be sent.'}`, 7000));
    }
  }

  private buildLinkedInCaption(url: string): string {
    const title = this.normalizeLinkedInCaptionText(this.formservice.title);
    const description = this.normalizeLinkedInCaptionText(this.formservice.description);
    const urlSegment = this.normalizeLinkedInCaptionText(url);
    const segments = [title, description, urlSegment].filter((segment) => !!segment);

    return this.truncateLinkedInCaption(segments.join('. '));
  }

  private normalizeLinkedInCaptionText(value: any): string {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private truncateLinkedInCaption(value: string, maxLength: number = this.linkedInCommentarySafeLength): string {
    return Array.from(value || '').slice(0, maxLength).join('').trim();
  }

  private buildFacebookCaption(url: string): string {
    const title = this.normalizeSocialCaptionText(this.formservice.title);
    const description = this.normalizeSocialCaptionText(this.formservice.description);
    const urlSegment = this.normalizeSocialCaptionText(url);
    const segments = [title, description, urlSegment].filter((segment) => !!segment);

    return this.truncateSocialCaption(segments.join('. '), this.facebookMessageSafeLength);
  }

  private normalizeSocialCaptionText(value: any): string {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private truncateSocialCaption(value: string, maxLength: number): string {
    return Array.from(value || '').slice(0, maxLength).join('').trim();
  }
  postToYouTube(){
    if (this.youTubeEnabled){
      this.setThirdPartyPublishStatus('processing', 'Sending your publication to YouTube…');
      const youtubeTitle = this.getThirdPartyPublicationTitle();
      const youtubeDescription = this.getThirdPartyPublicationDescription();

      this.request.createRequestPost('getAuthYouTubeToken', {mediaUrl:this.thirdPrtyMedia,thirdPrtyMediaType:this.thirdPrtyMediaType,  title:youtubeTitle,description:youtubeDescription,   })
		.then((data) => {

      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
		console.log(data);
    if(data.success) this.setThirdPartyPublishStatus('success', 'Your publication is live on YouTube.', 5000);
    else this.setThirdPartyPublishStatus('error', `YouTube: ${data?.message || data?.error || 'The publication was rejected.'}`, 7000);

	}).catch(error => this.setThirdPartyPublishStatus('error', `YouTube: ${error?.message || 'The publication could not be sent.'}`, 7000));
    }
  }

  private getThirdPartyPublicationTitle(): string {
    return (
      this.formservice.title ||
      this.formservice.normalpublication?.title ||
      this.formservice.lkpublication?.title ||
      this.formservice.earthpublication?.title ||
      this.formservice.eventospublication?.title ||
      this.formservice.epochpublication?.titleLeccion ||
      this.formservice.epochpublication?.title ||
      this.formservice.landpublication?.title2 ||
      this.formservice.landpublication?.title ||
      'Laniakea publication'
    ).toString().trim().slice(0, 100);
  }

  private getThirdPartyPublicationDescription(): string {
    const title = this.getThirdPartyPublicationTitle();
    return (
      this.formservice.description ||
      this.formservice.normalpublication?.description ||
      this.formservice.lkpublication?.description ||
      this.formservice.earthpublication?.description ||
      this.formservice.eventospublication?.description ||
      this.formservice.epochpublication?.descriptionLeccion ||
      this.formservice.epochpublication?.description ||
      this.formservice.landpublication?.description2 ||
      this.formservice.landpublication?.description ||
      title
    ).toString().trim().slice(0, 5000);
  }

  private captureWixPostMetadata(): void {
    this.wixPostTitle = this.getThirdPartyPublicationTitle();
    this.wixPostDescription = this.getThirdPartyPublicationDescription();
  }

  private getTikTokRequestErrorMessage(error: any): string {
    let payload = error?.error ?? error?.data ?? error;

    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch {
        return payload || 'TikTok could not publish the video.';
      }
    }

    const tiktokError = payload?.tiktok_error ?? payload?.error?.tiktok_error;
    if (tiktokError) {
      const code = tiktokError.code && tiktokError.code !== 'ok' ? ` (${tiktokError.code})` : '';
      return `${tiktokError.message || 'TikTok rejected the publication.'}${code}`;
    }

    return payload?.message
      || (typeof payload?.error === 'string' ? payload.error : null)
      || error?.message
      || 'TikTok could not publish the video.';
  }

  private isTikTokVerifiedVideoUrl(mediaUrl: string): boolean {
    try {
      const url = new URL(mediaUrl);
      if (url.protocol !== 'https:') return false;
      const host = url.hostname.toLowerCase();
      return host === 'laniakea-multimedia.s3.amazonaws.com'
        || (host.startsWith('laniakea-multimedia.s3-') && host.endsWith('.amazonaws.com'))
        || (host === 's3.amazonaws.com' && url.pathname.startsWith('/laniakea-multimedia/'))
        || (host === 's3-us-east-1.amazonaws.com' && url.pathname.startsWith('/laniakea-multimedia/'));
    } catch {
      return false;
    }
  }

  async postToTikTok(){
    if (this.tiktokEnabled){
      this.setThirdPartyPublishStatus('processing', 'Sending your publication to TikTok…');
      if (this.thirdPrtyMediaType === 'imagen' && this.tiktokPhotoEnabled) {
        this.applyTikTokPhotoDefaults();
      }
      let video_cover_timestamp_ms= this.video_cover_timestamp_ms;
      const payload: any = {mediaUrl:this.thirdPrtyMedia,video_cover_timestamp_ms:video_cover_timestamp_ms,thirdPrtyMediaType:this.thirdPrtyMediaType, tiktokDraftEnabled:this.tiktokDraftEnabled,tiktokDirectPost:this.tiktokDirectPost, imagesArray: this.images_compatible_to_tiktok, title:this.formservice.title,description:this.formservice.description,  tiktok_privacy: this.tiktok_privacy, tiktok_comment_disabled:this.tiktok_comment_disabled, tiktok_auto_add_music:this.tiktok_auto_add_music, disable_duet:!this.tiktokDuetEnabled, disable_stitch:!this.tiktokStitchEnabled};
      let requestPromise: Promise<any>;
      try {
        if (this.thirdPrtyMediaType === 'video' && !this.isTikTokVerifiedVideoUrl(this.thirdPrtyMedia)) {
          const sourceResponse = await fetch(this.thirdPrtyMedia);
          if (!sourceResponse.ok) throw new Error(`No se pudo descargar el video para TikTok (${sourceResponse.status}).`);
          const formData = new FormData();
          Object.keys(payload).forEach(key => {
            const value = payload[key];
            if (value !== undefined && value !== null) formData.append(key, Array.isArray(value) ? JSON.stringify(value) : String(value));
          });
          formData.append('video_file', await sourceResponse.blob(), 'tiktok-video.mp4');
          requestPromise = this.request.createRequestPostMultipart('postToTikTok', formData);
        } else {
          requestPromise = this.request.createRequestPost('postToTikTok', payload);
        }
      } catch (error) {
        this.setThirdPartyPublishStatus('error', `TikTok: ${this.getTikTokRequestErrorMessage(error)}`, 7000);
        return;
      }
      requestPromise
		.then((data) => {
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('getRecordByToken ios:',data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
		// Open the login URL in the system browser
      this.formservice.TikTok=1;
		console.log(data);
    if(data.success) this.setThirdPartyPublishStatus('success', 'Your publication was sent to TikTok.', 5000);
    else this.setThirdPartyPublishStatus('error', `TikTok: ${this.getTikTokRequestErrorMessage(data)}`, 7000);

	}).catch((error) => {
      this.setThirdPartyPublishStatus('error', `TikTok: ${this.getTikTokRequestErrorMessage(error)}`, 7000);
	});
    }
  }
  public post() {
    this.wixPostSent = false;
    const currentMultimedia = this.formservice.normalpublication.blobsMultimedia || [];
    const validMultimedia = currentMultimedia.filter((item: any) => item && item.blob);
    if (validMultimedia.length !== currentMultimedia.length) {
      console.warn('Skipping invalid multimedia entries without blob payload.');
      this.formservice.normalpublication.blobsMultimedia = validMultimedia;
    }
    this.resetTikTokPhotoBatch(validMultimedia);

    if (this.instagramEnabled && this.getPubTypeForCurrentMedia() === 'video' &&
        !this.instagramStoriesEnabled && !this.instagramReelsEnabled) {
      Swal2.fire({
        title: 'Publicación en Insta',
        text: 'Debes elegir si publicar el contenido a tus historias o a reel',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    if(this.tiktokEnabled && this.tiktokDraftEnabled && !this.tiktokPhotoEnabled && !this.tiktokVideoEnabled){
      Swal2.fire({
        title: 'Publicación en TikTok',
        text: 'Debes elegir el tipo de media del borrador a tu bandeja (video/photo).',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    /*
    if(this.instagramEnabled && !this.instagram_profile_photo){
      Swal2.fire({
        title: 'Publicación en Instagram',
        text: 'Debes autenticarte antes de activar publicaciones a Instagram',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }*/
    if(this.tiktokEnabled && !this.tiktokDraftEnabled && !this.tiktokDirectPost){
      Swal2.fire({
        title: 'Publicación en TikTok',
        text: 'Debes elegir si enviar como borrador a tu bandeja o publicacón directa',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    if(this.tiktokEnabled  && !this.tiktokDraftEnabled && !this.tiktok_privacy ){
      Swal2.fire({
        title: 'Publicación en TikTok',
        text: 'Debes elegir la privacidad de la publicación',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    if(this.tiktok_Content_Disclosure_Setting && !this.tiktok_contenido_de_marca && !this.tiktok_tu_marca  && !this.tiktokDraftEnabled){
      Swal2.fire({
        title: 'Publicación en TikTok',
        text: 'Debes indicar si tu contenido te promociona a ti mismo, a un tercero o a ambos.',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    if(this.tiktok_privacy ==='SELF_ONLY' && this.tiktok_Content_Disclosure_Setting  && !this.tiktokDraftEnabled){
      Swal2.fire({
        title: 'Publicación en TikTok',
        text: 'La visibilidad del contenido de marca no puede ser privada.',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    if (this.browsersEnabled && this.laniakea_image_url?.trim() && !this.isValidLaniakeaImageUrl()) {
      Swal2.fire({
        title: 'Publicación en navegadores',
        text: 'La URL de imagen debe comenzar con http:// o https://.',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    if (this.browsersEnabled && !this.navigator_language) {
      Swal2.fire({
        title: 'Publicación en navegadores',
        text: 'Debes seleccionar un idioma para publicar en google.',
        icon: 'error',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }

    this.uploadmultimedia.beginThirdPartyPublish(
      this.getSelectedThirdPartyPlatforms(validMultimedia),
    );

    console.log("Estoy dentro del post");
    console.log('formserivce', this.formservice);
    
    if (this.formservice.publication_type === 'normal') {
      console.log('normal form', this.formservice.normalpublication.getPublicationsDataToSend());
      this.captureWixPostMetadata();
      this.utils.loadingPresent().then(async () => {
        try {
          let data: any = await this.publicationService.postPublication(
            this.formservice.normalpublication.getPublicationsDataToSend()
          );
            if (Capacitor.getPlatform() !== 'web') {
              data = typeof data === 'string' ? JSON.parse(data) : data;
            }else{
              if (typeof data === 'string') {
                data = JSON.parse(data);
                   console.log('json result publication service.ts', data);
                 
                 }else {
                  data = data; 
                 }
            }
            let publication_ids: Array<number> = [];
            publication_ids.push(Number(data?.id ?? data?.data?.id ?? data?.publication?.id));
            if (!Number.isSafeInteger(publication_ids[0]) || publication_ids[0] <= 0) {
              throw new Error('Laniakea did not return the new publication ID.');
            }
            console.log("publication_id",publication_ids);
            const mediaToUpload = [...(this.formservice.normalpublication.blobsMultimedia || [])];
            await Promise.all(mediaToUpload.map(async (element, index, array) => {
                console.log("Elemento",element);
                const { link, mimeType, posterLink } = await this.uploadmultimedia.post(element.blob, element.filename);
                const ruta = link;
               // const ruta = r[0];
                //const mimeType = r[1];
                console.log('ruta', ruta);
                let pub_type = '';
                //console.log(this.multimedia[0].typeData);
                if(mimeType.includes("image")) {
                  pub_type= 'imagen';
                }else if(mimeType.includes("video")){
                  pub_type= 'video';
                }
             
                let is_premium_m: boolean;
                console.log('is premium', element.isPremium);
                if(element.isPremium === undefined){
                  console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                  is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                }else{
                  is_premium_m = element.isPremium;
                }
                const objmedia = {
                  route: ruta,
                  // The API share-preview route uses this image for video OG
                  // metadata. Undefined is omitted when the device cannot
                  // decode the source video, allowing the API fallback chain.
                  thumbnail_url: posterLink,
                  size: 800,
                  type:pub_type,
                  publication_type: this.formservice.publication_type,
                  publication_id: publication_ids[0],
                  is_premium: is_premium_m
                };
        
                console.log('objmedia', objmedia);
                const final_data = await this.request.createRequestPost('publications.multimedia', objmedia);
                this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0], posterLink);
                console.log('request history final data',final_data);
            }));

            console.log('finalizado subir multimedias');
            this.formservice.normalpublication.blobsMultimedia = []
            this.utils.loadingDismiss();
            await this.finishNormalPublication(publication_ids[0]);
        } catch (error) {
            Swal2.fire({
              title: 'Error al subir multimedia!',
              text: error?.message || 'Ocurrió un error al guardar la publicación. Inténtalo de nuevo.',
              icon: 'warning',
              confirmButtonText: 'Understood',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
            this.utils.loadingDismiss();
        }
      });
    }
    
    if (this.formservice.publication_type === 'lkfilm') {
      this.utils.loadingPresent().then(() => {
        this.publicationService
          .postPublication(
            this.formservice.lkpublication.getPublicationsDataToSend()
          ).then((data: any) => {
            if (Capacitor.getPlatform() !== 'web') {
          data = JSON.parse(data); // En una Historia el id devuelto debe ser el del estado recientemente agregado
        }else{
          if (typeof data === 'string') {
            data = JSON.parse(data);
               console.log('json result publication service.ts', data);
             
             }else {
              data = data; 
             }
        }
          let publication_ids: Array<number> = [];
          publication_ids.push(data.id);
          if (data.publication_type == 'story' && data.state_id != null) {
            publication_ids.push(data.state_id);
          }
          console.log(data);
          this.utils.loadingDismiss();
         // if (this.formservice.lkpublication.multimedia.length != 0) {
            //En una historia el multimedia container lo deberia tener un estado
            //this.utils.alertPresent('En Preparación', 'Le notificaremos cuando pueda ver su publicación', 'OK');
            this.formservice.normalpublication.blobsMultimedia.forEach((element, index, array) => {
              console.log("Elemento", element);
              this.uploadmultimedia.post(element.blob, element.filename).then(({ link, mimeType }) => {
                const ruta = link;
               // const ruta = r[0];
                //const mimeType = r[1];
                console.log('ruta', ruta);
                let pub_type = '';
                //console.log(this.multimedia[0].typeData);
                if (mimeType.includes("image")) {
                  pub_type = 'imagen';
                } else if (mimeType.includes("video")) {
                  pub_type = 'video';
                }
                let is_premium_m: boolean;
                console.log('is premium', element.isPremium);
                if(element.isPremium === undefined){
                  console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                  is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                }else{
                  is_premium_m = element.isPremium;
                }
                const objmedia = {
                  route: ruta,
                  size: 800,
                  type: pub_type,
                  publication_type: this.formservice.publication_type,
                  publication_id: publication_ids[0],
                  is_premium: is_premium_m,
                };
               
                console.log('objmedia', objmedia);
                this.request.createRequestPost('publications.multimedia', objmedia).then((final_data) => {
                  this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0]);
                  console.log('request history final data', final_data);

                }).catch((error) => {
                  this.utils.loadingDismiss();
                  Swal2.fire({
                    title: 'Error al subir multimedia!',
                    text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
                    icon: 'warning',
                    confirmButtonText: 'Understood',
                    color: '#ffffff',
                    background: '#010f4e',
                    position: 'top-end',
                    timerProgressBar: true,
                    toast: true,
                  });

                });

              });
            });
         // }
          console.log('finalizado subir multimedias');
          this.utils.loadingDismiss();
          this.formservice.normalpublication.blobsMultimedia = []
          this.back();
        }).catch((error)=>{
            this.utils.loadingDismiss();
            Swal2.fire({
              title: 'Error al subir publicacion!',
              text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
              icon: 'warning',
              confirmButtonText: 'Understood',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
        });
      });
    }
    if (this.formservice.publication_type === 'epoch') {
      this.utils.loadingPresent().then(() => {
        this.publicationService
          .postPublication(
            this.formservice.epochpublication.getPublicationsDataToSend()
          )
          .then((data: any) => {
          
            if (Capacitor.getPlatform() !== 'web') {
              data = JSON.parse(data); // En una Historia el id devuelto debe ser el del estado recientemente agregado
            }else{
              if (typeof data === 'string') {
                data = JSON.parse(data);
                   console.log('json result publication service.ts', data);
                 
                 }else {
                  data = data; 
                 }
            }
              let publication_ids: Array<number> = [];
              publication_ids.push(data.id);
              if (data.publication_type == 'story' && data.state_id != null) {
                publication_ids.push(data.state_id);
              }
            console.log(data);
            this.utils.loadingDismiss();
       
             // if (this.formservice.landpublication.multimedia.length != 0) {
              this.formservice.normalpublication.blobsMultimedia.forEach((element, index, array) => {
                  console.log("Elemento",element);
                  this.uploadmultimedia.post(element.blob, element.filename).then(({ link, mimeType }) => {
                    const ruta = link;
                   // const ruta = r[0];
                    //const mimeType = r[1];
                    console.log('ruta', ruta);
                    let pub_type = '';
                    //console.log(this.multimedia[0].typeData);
                    if(mimeType.includes("image")) {
                      pub_type= 'imagen';
                    }else if(mimeType.includes("video")){
                      pub_type= 'video';
                    }
                    let is_premium_m: boolean;
                    console.log('is premium', element.isPremium);
                    if(element.isPremium === undefined){
                      console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                      is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                    }else{
                      is_premium_m = element.isPremium;
                    }
                    const objmedia = {
                      route: ruta,
                      size: 800,
                      type:pub_type,
                      publication_type: this.formservice.publication_type,
                      publication_id: publication_ids[0],
                      is_premium: is_premium_m
                    };
                   
                    console.log('objmedia', objmedia);
                    this.request.createRequestPost('publications.multimedia',objmedia).then((final_data) => {
                      this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0]);
                      console.log('request history final data',final_data);
                      this.dismissEpoch();
                    }).catch((error) => {
                      this.utils.loadingDismiss();
                      Swal2.fire({
                        title: 'Error al subir multimedia!',
                        text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
                        icon: 'warning',
                        confirmButtonText: 'Understood',
                        color: '#ffffff',
                        background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
                      });
    
                    });
    
                  });
                });
          /*  if (this.formservice.epochpublication.multimedia.length != 0) {
              //En una historia el multimedia container lo deberia tener un estado
              //this.utils.alertPresent('En Preparación', 'Le notificaremos cuando pueda ver su publicación', 'OK');
              this.cameraService
                .postArrayMultimedia(
                  this.formservice.epochpublication.multimedia,
                  publication_ids,
                  'publications',
                  this.formservice.publication_type
                )
                .finally(() => {
                  this.updateStatusPublication(publication_ids)
                    .then(() => {
                      this.publicationService
                        .getPublicationByID(publication_ids[0], true)
                        .then((publication) => {
                          // De ser una historia la publicacion recien creada se debe agregar o reemplazar la historia actual
                          console.log(publication);
                          if (publication.publication_type == 'story') {
                            this.publicationService.updatePublicationList(
                              'MyStoriesList',
                              publication,
                              true
                            );
                          } else {
                            this.publicationService.updatePublicationList(
                              'MyepochList',
                              publication,
                              true
                            );
                            this.publicationService.updatePublicationList(
                              'MyPublicationsList',
                              publication,
                              true
                            );
                            this.dismissEpoch();
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                  //this.publicationService.updatePublicationList('MyepochList', data, true);
                  //this.publicationService.updatePublicationList('MyPublicationsList', data, true);
                });
              this.publicationService.updatePublicationList(
                'MyepochList',
                data,
                true
              );
              this.publicationService.updatePublicationList(
                'MyPublicationsList',
                data,
                true
              );
            } else {
              //this.utils.alertPresent('Exito', 'Publicación realizada con exito', 'OK');
              this.publicationService.updatePublicationList(
                'MyepochList',
                data,
                true
              );
              this.publicationService.updatePublicationList(
                'MyPublicationsList',
                data,
                true
              );

              
              this.dismissEpoch();
              // this.cancelButton();
            }
            */
          })
          .catch((error) => {
            console.error(error);
            this.utils.loadingDismiss();
          });

      });
    
    }
    if (this.formservice.publication_type === 'land') {
      this.utils.loadingPresent().then(() => {
        this.publicationService
          .postPublication(
            this.formservice.landpublication.getPublicationsDataToSend()
          )
          .then((data: any) => {
            if (Capacitor.getPlatform() !== 'web') {
            data = JSON.parse(data); // En una Historia el id devuelto debe ser el del estado recientemente agregado
          }else{
            if (typeof data === 'string') {
              data = JSON.parse(data);
                 console.log('json result publication service.ts', data);
               
               }else {
                data = data; 
               }
          }
            let publication_ids: Array<number> = [];
            publication_ids.push(data.id);
            if (data.publication_type == 'story' && data.state_id != null) {
              publication_ids.push(data.state_id);
            }
            console.log("Data information", data);
            this.utils.loadingDismiss();
           // if (this.formservice.landpublication.multimedia.length != 0) {
            this.formservice.normalpublication.blobsMultimedia.forEach((element, index, array) => {
                console.log("Elemento",element);
                this.uploadmultimedia.post(element.blob, element.filename).then(({ link, mimeType }) => {
                  const ruta = link;
                 // const ruta = r[0];
                  //const mimeType = r[1];
                  console.log('ruta', ruta);
                  let pub_type = '';
                  //console.log(this.multimedia[0].typeData);
                  if(mimeType.includes("image")) {
                    pub_type= 'imagen';
                  }else if(mimeType.includes("video")){
                    pub_type= 'video';
                  }
                  let is_premium_m: boolean;
                  console.log('is premium', element.isPremium);
                  if(element.isPremium === undefined){
                    console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                    is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                  }else{
                    is_premium_m = element.isPremium;
                  }
                  const objmedia = {
                    route: ruta,
                    size: 800,
                    type:pub_type,
                    publication_type: this.formservice.publication_type,
                    publication_id: publication_ids[0],
                    is_premium: is_premium_m
                  };
               
                  console.log('objmedia', objmedia);
                  this.request.createRequestPost('publications.multimedia',objmedia).then((final_data) => {
                    this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0]);
                    console.log('request history final data',final_data);
                  }).catch((error) => {
                    this.utils.loadingDismiss();
                    Swal2.fire({
                      title: 'Error al subir multimedia!',
                      text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
                      icon: 'warning',
                      confirmButtonText: 'Understood',
                      color: '#ffffff',
                      background: '#010f4e',
                      position: 'top-end',
                      timerProgressBar: true,
                      toast: true,
                    });
  
                  });
  
                });
              });
              //En una historia el multimedia container lo deberia tener un estado
              //this.utils.alertPresent('En Preparación', 'Le notificaremos cuando pueda ver su publicación', 'OK');
              //this.cameraService
               // .postArrayMultimedia(
               //   this.formservice.landpublication.multimedia,
               //   publication_ids,
              //    'publications',
               //   this.formservice.publication_type
               // )
               // .finally(() => {
               //   this.updateStatusPublication(publication_ids)
               //     .then(() => {
               //       this.publicationService
              //          .getPublicationByID(publication_ids[0], true)
              //          .then((publication) => {
                          // De ser una historia la publicacion recien creada se debe agregar o reemplazar la historia actual
                //          console.log(publication);
                          //if (publication.publication_type == 'story') {
                            //this.publicationService.updatePublicationList(
                              //'MyStoriesList',
                             // publication,
                           //   true
                           // );
                          //} else {
                          ///  this.publicationService.updatePublicationList(
                          ///    'MylandList',
                           //   publication,
                          //    true
                          //  );
                         //   this.publicationService.updatePublicationList(
                         //     'MyPublicationsList',
                         //     publication,
                        //      true
                        //    );
                            this.dismissLand();
                         // }
                        //})
                       // .catch((error) => {
                      //    console.error(error);
                      //  });
                    //})
                   // .catch((error) => {
                   //   console.error(error);
                   // });
                  //this.publicationService.updatePublicationList('MylandList', data, true);
                  //this.publicationService.updatePublicationList('MyPublicationsList', data, true);
              //  });
              //this.publicationService.updatePublicationList(
             //   'MylandList',
             //   data,
            //    true
           //   );
             // this.publicationService.updatePublicationList(
           //     'MyPublicationsList',
          //      data,
            //    true
            //  );
           // } else {
              //this.utils.alertPresent('Exito', 'Publicación realizada con exito', 'OK');
             // this.publicationService.updatePublicationList(
            //    'MylandList',
            //    data,
           //     true
          //    );
         //     this.publicationService.updatePublicationList(
        //        'MyPublicationsList',
        //        data,
        //        true
          //    );
              this.dismissLand();
              // this.cancelButton();
           // }
          })
          .catch((error) => {
            console.error(error);
            this.utils.loadingDismiss();
          });
      });
    }
    if (this.formservice.publication_type === 'earth') {
      this.utils.loadingPresent().then(() => {
        this.publicationService
          .postPublication(
            this.formservice.earthpublication.getPublicationsDataToSend()
          )
          .then((data: any) => {
            if (Capacitor.getPlatform() !== 'web') {
              data = JSON.parse(data); // En una Historia el id devuelto debe ser el del estado recientemente agregado
            }else{
              if (typeof data === 'string') {
                data = JSON.parse(data);
                   console.log('json result publication service.ts', data);
                 
                 }else {
                  data = data; 
                 }
            }
              let publication_ids: Array<number> = [];
              publication_ids.push(data.id);
              if (data.publication_type == 'story' && data.state_id != null) {
                publication_ids.push(data.state_id);
              }
              console.log("Data information", data);
              this.utils.loadingDismiss();
           // if (this.formservice.landpublication.multimedia.length != 0) {
            this.formservice.normalpublication.blobsMultimedia.forEach((element, index, array) => {
                console.log("Elemento",element);
                this.uploadmultimedia.post(element.blob, element.filename).then(({ link, mimeType }) => {
                  const ruta = link;
                 // const ruta = r[0];
                  //const mimeType = r[1];
                  console.log('ruta', ruta);
                  let pub_type = '';
                  //console.log(this.multimedia[0].typeData);
                  if(mimeType.includes("image")) {
                    pub_type= 'imagen';
                  }else if(mimeType.includes("video")){
                    pub_type= 'video';
                  }
                  let is_premium_m: boolean;
                  console.log('is premium', element.isPremium);
                  if(element.isPremium === undefined){
                    console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                    is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                  }else{
                    is_premium_m = element.isPremium;
                  }
                  const objmedia = {
                    route: ruta,
                    size: 800,
                    type:pub_type,
                    publication_type: this.formservice.publication_type,
                    publication_id: publication_ids[0],
                    is_premium: is_premium_m
                  };
                
                  console.log('objmedia', objmedia);
                  this.request.createRequestPost('publications.multimedia',objmedia).then((final_data) => {
                    this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0]);
                    console.log('request history final data',final_data);
                    this.dismissEarth();
                  }).catch((error) => {
                    this.utils.loadingDismiss();
                    Swal2.fire({
                      title: 'Error al subir multimedia!',
                      text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
                      icon: 'warning',
                      confirmButtonText: 'Understood',
                      color: '#ffffff',
                      background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
                    });
  
                  });
  
                });
              });
            /*
            console.log(data);
            this.utils.loadingDismiss();
            if (this.formservice.earthpublication.multimedia.length != 0) {
              //En una historia el multimedia container lo deberia tener un estado
              //this.utils.alertPresent('En Preparación', 'Le notificaremos cuando pueda ver su publicación', 'OK');
              this.cameraService
                .postArrayMultimedia(
                  this.formservice.earthpublication.multimedia,
                  publication_ids,
                  'publications',
                  this.formservice.publication_type
                )
                .finally(() => {
                  this.updateStatusPublication(publication_ids)
                    .then(() => {
                      this.publicationService
                        .getPublicationByID(publication_ids[0], true)
                        .then((publication) => {
                          // De ser una historia la publicacion recien creada se debe agregar o reemplazar la historia actual
                          console.log(publication);
                          if (publication.publication_type == 'story') {
                            this.publicationService.updatePublicationList(
                              'MyStoriesList',
                              publication,
                              true
                            );
                          } else {
                            this.publicationService.updatePublicationList(
                              'MyearthList',
                              publication,
                              true
                            );
                            this.publicationService.updatePublicationList(
                              'MyPublicationsList',
                              publication,
                              true
                            );
                            this.dismissEarth();
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                  //this.publicationService.updatePublicationList('MyearthList', data, true);
                  //this.publicationService.updatePublicationList('MyPublicationsList', data, true);
                });
              this.publicationService.updatePublicationList(
                'MyearthList',
                data,
                true
              );
              this.publicationService.updatePublicationList(
                'MyPublicationsList',
                data,
                true
              );
            } else {
              //this.utils.alertPresent('Exito', 'Publicación realizada con exito', 'OK');
              this.publicationService.updatePublicationList(
                'MyearthList',
                data,
                true
              );
              this.publicationService.updatePublicationList(
                'MyPublicationsList',
                data,
                true
              );
              this.dismissEarth();
              // this.cancelButton();
            }
            */
          })
          .catch((error) => {
            console.error(error);
            this.utils.loadingDismiss();
          });
      });
     
    }
    if (this.formservice.publication_type === 'LK MUSIC') {
      console.log('normal form', this.formservice.normalpublication.getPublicationsDataToSend());
      let data=  this.formservice.normalpublication.get_LK_MUSIC_DataToSend();
      data.data.audio_duration=this.audio_duration;
      data.data.audio_start_value=this.audio_start_value;
      this.utils.loadingPresent().then(() => {
        this.publicationService
          .postPublication(
            data
          )
          .then((data: any) => {
            if (Capacitor.getPlatform() !== 'web') {
            data = JSON.parse(data); // En una Historia el id devuelto debe ser el del estado recientemente agregado
            }else{
              if (typeof data === 'string') {
                data = JSON.parse(data);
                   console.log('json result publication service.ts', data);
                 
                 }else {
                  data = data; 
                 }
            }
            let publication_ids: Array<number> = [];
            publication_ids.push(data.id);
            console.log("publication_id",publication_ids);
            this.utils.loadingDismiss();
            this.formservice.normalpublication.blobsMultimedia.forEach((element, index, array) => {
              console.log("Elemento",element);
              this.uploadmultimedia.post(element.blob, element.filename).then(({ link, mimeType }) => {
                
                const ruta = link;
               // const ruta = r[0];
                //const mimeType = r[1];
                console.log('ruta', ruta);
                let pub_type = '';
                let is_premium_m: boolean;
                //console.log(this.multimedia[0].typeData);
                if(mimeType.includes("image")) {
                  pub_type= 'imagen';
                }else if(mimeType.includes("video")){
                  pub_type= 'video';
               }else {//audio 
                  pub_type= 'audio';

                }
             
           
                console.log('is premium', element.isPremium);
                if(element.isPremium === undefined){
                  console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                  is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                }else{
                  is_premium_m = element.isPremium;
                }
                if( this.formservice.price !== 0 ){
                  is_premium_m=true;
                }
                const objmedia = {
                  route: ruta,
                  size: 800,
                  type:pub_type,
                  publication_type: this.formservice.publication_type,
                  publication_id: publication_ids[0],
                  is_premium: is_premium_m
                };
        
                console.log('objmedia', objmedia);
                this.request.createRequestPost('publications.multimedia',objmedia).then((final_data) => {
                  this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0]);
                  console.log('request history final data',final_data);
                 
                }).catch((error) => {
                  this.utils.loadingDismiss();
                  Swal2.fire({
                    title: 'Error al subir multimedia!',
                    text: error,
                    icon: 'warning',
                    confirmButtonText: 'Understood',
                    color: '#ffffff',
                    background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
                  });

                });

              });
            });
           
            console.log('finalizado subir multimedias');
            this.utils.loadingDismiss();
            this.formservice.normalpublication.blobsMultimedia = []
            this.back();
          })
          .catch((error) => {
            Swal2.fire({
              title: 'Error al subir multimedia!',
              text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
              icon: 'warning',
              confirmButtonText: 'Understood',
              color: '#ffffff',
              background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
            });
            this.utils.loadingDismiss();
          });
      });
    }


    
    if (this.formservice.publication_type === 'feex') {

      if (
        !this.formservice.feexpublication.additional_price || 
        !this.formservice.feexpublication.stock || 
        !this.formservice.feexpublication.isNew || 
        !this.formservice.feexpublication.ubicacion || 
        !this.formservice.feexpublication.marca || 
        !this.formservice.feexpublication.envio || 
        !this.formservice.feexpublication.category || 
        !this.formservice.feexpublication.tiempo_garantia || 
        !this.formservice.feexpublication.garantia || 
        !this.formservice.feexpublication.envio_gratis || 
        !this.formservice.feexpublication.accessories ||
        !this.formservice.feexpublication.postal_code
      ) {
        Swal2.fire({
          title: 'Error, llena todos los campos correctamente',
          text: 'Ocurrió un error inesperado. Si persiste, comunícate con el soporte de Laniakea',
          icon: 'error',
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
        return;
      }
      this.utils.loadingPresent().then(() => {
        this.publicationService
          .postPublication(
            this.formservice.feexpublication.getPublicationsDataToSend()
          )
          .then((data: any) => {
            if (Capacitor.getPlatform() !== 'web') {
            data = JSON.parse(data); // En una Historia el id devuelto debe ser el del estado recientemente agregado
            }else{
              if (typeof data === 'string') {
                data = JSON.parse(data);
                   console.log('json result publication service.ts', data);
                 
                 }else {
                  data = data; 
                 }
            }
            let publication_ids: Array<number> = [];
            publication_ids.push(data.id);
            console.log("publication_id",publication_ids);
            this.utils.loadingDismiss();
            this.formservice.normalpublication.blobsMultimedia.forEach((element, index, array) => {
              console.log("Elemento",element);
              this.uploadmultimedia.post(element.blob, element.filename).then(({ link, mimeType }) => {
                
                const ruta = link;
               // const ruta = r[0];
                //const mimeType = r[1];
                console.log('ruta', ruta);
                let pub_type = '';
                //console.log(this.multimedia[0].typeData);
                if(mimeType.includes("image")) {
                  pub_type= 'imagen';
                }else if(mimeType.includes("video")){
                  pub_type= 'video';
                }
             
                let is_premium_m: boolean;
                console.log('is premium', element.isPremium);
                if(element.isPremium === undefined){
                  console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                  is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                }else{
                  is_premium_m = element.isPremium;
                }
                const objmedia = {
                  route: ruta,
                  size: 800,
                  type:pub_type,
                  publication_type: this.formservice.publication_type,
                  publication_id: publication_ids[0],
                  is_premium: is_premium_m
                };
        
                console.log('objmedia', objmedia);
                this.request.createRequestPost('publications.multimedia',objmedia).then((final_data) => {
                  this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0]);
                  console.log('request history final data',final_data);
                 
                }).catch((error) => {
                  this.utils.loadingDismiss();
                  Swal2.fire({
                    title: 'Error al subir multimedia!',
                    text: error,
                    icon: 'warning',
                    confirmButtonText: 'Understood',
                    color: '#ffffff',
                    background: '#010f4e',
                    position: 'top-end',
                    timerProgressBar: true,
                    toast: true,
                  });

                });

              });
            });
           
            console.log('finalizado subir multimedias');
            this.utils.loadingDismiss();
            this.formservice.normalpublication.blobsMultimedia = []
            this.back();
          })
          .catch((error) => {
            Swal2.fire({
              title: 'Error al subir multimedia!',
              text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
              icon: 'warning',
              confirmButtonText: 'Understood',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
            });
            this.utils.loadingDismiss();
          });
      });
    }
    if (this.formservice.publication_type === 'eventos') {
      this.utils.loadingPresent().then(() => {
        this.publicationService
          .postPublication(
            this.formservice.eventospublication.getPublicationsDataToSend()
          )
          .then((data: any) => {
            if (Capacitor.getPlatform() !== 'web') {
              data = JSON.parse(data); // En una Historia el id devuelto debe ser el del estado recientemente agregado
            }else{
              if (typeof data === 'string') {
                data = JSON.parse(data);
                   console.log('json result publication service.ts', data);
                 
                 }else {
                  data = data; 
                 }
            }
              let publication_ids: Array<number> = [];
              publication_ids.push(data.id);
              if (data.publication_type == 'story' && data.state_id != null) {
                publication_ids.push(data.state_id);
              }
            console.log("Data information", data);
            this.utils.loadingDismiss();
           // if (this.formservice.landpublication.multimedia.length != 0) {
            this.formservice.normalpublication.blobsMultimedia.forEach((element, index, array) => {
                console.log("Elemento",element);
                this.uploadmultimedia.post(element.blob, element.filename).then(({ link, mimeType }) => {
                  const ruta = link;
                 // const ruta = r[0];
                  //const mimeType = r[1];
                  console.log('ruta', ruta);
                  let pub_type = '';
                  //console.log(this.multimedia[0].typeData);
                  if(mimeType.includes("image")) {
                    pub_type= 'imagen';
                  }else if(mimeType.includes("video")){
                    pub_type= 'video';
                  }
                  let is_premium_m: boolean;
                  console.log('is premium', element.isPremium);
                  if(element.isPremium === undefined){
                    console.log('current multimedia status', this.formservice.normalpublication.current_multimedia_status);
                    is_premium_m = this.formservice.normalpublication.current_multimedia_status;
                  }else{
                    is_premium_m = element.isPremium;
                  }
                  const objmedia = {
                    route: ruta,
                    size: 800,
                    type:pub_type,
                    publication_type: this.formservice.publication_type,
                    publication_id: publication_ids[0],
                    is_premium: is_premium_m
                  };

                  console.log('objmedia', objmedia);
                  this.request.createRequestPost('publications.multimedia',objmedia).then((final_data) => {
                    this.thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids[0]);
                    this.dismissEventos();
                    console.log('request history final data',final_data);
                  }).catch((error) => {
                    this.utils.loadingDismiss();
                    Swal2.fire({
                      title: 'Error al subir multimedia!',
                      text: 'Ocurrió un error inseperado, si persiste comunícate con el soprte de Laniakea',
                      icon: 'warning',
                      confirmButtonText: 'Understood',
                      color: '#ffffff',
                      background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
                    });
  
                  });
  
                });
              });
         /*   console.log(data);
            this.utils.loadingDismiss();
            if (this.formservice.eventospublication.multimedia.length != 0) {
              //En una historia el multimedia container lo deberia tener un estado
              //this.utils.alertPresent('En Preparación', 'Le notificaremos cuando pueda ver su publicación', 'OK');
              this.cameraService
                .postArrayMultimedia(
                  this.formservice.eventospublication.multimedia,
                  publication_ids,
                  'publications',
                  this.formservice.publication_type
                )
                .finally(() => {
                  this.updateStatusPublication(publication_ids)
                    .then(() => {
                      this.publicationService
                        .getPublicationByID(publication_ids[0], true)
                        .then((publication) => {
                          // De ser una historia la publicacion recien creada se debe agregar o reemplazar la historia actual
                          console.log(publication);
                          if (publication.publication_type == 'story') {
                            this.publicationService.updatePublicationList(
                              'MyStoriesList',
                              publication,
                              true
                            );
                          } else {
                            this.publicationService.updatePublicationList(
                              'MyeventosList',
                              publication,
                              true
                            );
                            this.publicationService.updatePublicationList(
                              'MyPublicationsList',
                              publication,
                              true
                            );
                            this.dismissEventos();
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                  //this.publicationService.updatePublicationList('MyeventosList', data, true);
                  //this.publicationService.updatePublicationList('MyPublicationsList', data, true);
                });
              this.publicationService.updatePublicationList(
                'MyeventosList',
                data,
                true
              );
              this.publicationService.updatePublicationList(
                'MyPublicationsList',
                data,
                true
              );
            } else {
              //this.utils.alertPresent('Exito', 'Publicación realizada con exito', 'OK');
              this.publicationService.updatePublicationList(
                'MyeventosList',
                data,
                true
              );
              this.publicationService.updatePublicationList(
                'MyPublicationsList',
                data,
                true
              );
              this.dismissEventos();
              // this.cancelButton();
            }
            */
          })
          .catch((error) => {
            console.error(error);
            this.utils.loadingDismiss();
          });
      });
     
    }

  }

  public updateStatusPublication(publication_ids: Array<number>) {
    // Log the publication_ids array
    console.log('publication_ids:', publication_ids);
    return new Promise((resolve, reject) => {
      const status = {
        publication_type: 'publication',
        data: {
          publication_status_id: 1,
        },
      };
      this.publicationService
        .putPublication(status, publication_ids[0])
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async emitTwitterToggleEvent(){
    if (!this.twitterEnabled || this.checkingXConnection) return;
    this.checkingXConnection = true;
    try {
      let data: any = await this.request.createRequestPost('getAuthXProfile', {});
      if (!this.twitterEnabled) return;
      if (typeof data === 'string') data = JSON.parse(data);
      const profile = data?.success && data?.tp_user;
      if (profile?.username) {
        this.twitter_profile_photo = profile.profile_image_url;
        this.twitter_username = profile.username;
        this.twitter_privacy_level_options = profile.protected;
        this.twitter_followers = profile.followers_count;
        this.twitter_following = profile.following_count;
        this.twitter_likes_count = profile.like_count;
        this.twitter_content_count = profile.tweet_count;
        this.twitter_is_verified = profile.verified;
        this.twitter_profile_deep_link = profile.url;
        this.twitter_profile_bio_description = profile.description;
        return;
      }
    } catch (error) {
      console.error('Unable to check X connection:', error);
    } finally {
      this.checkingXConnection = false;
    }

    this.twitterEnabled = false;
    if (this.twitter_toggleElement) this.twitter_toggleElement.checked = false;
    if (window.confirm('Activaste la opción para publicar en X (Twitter). Para publicar contenido en tu cuenta de X, primero debes iniciar sesión. ¿Quieres iniciar sesión ahora?')) {
      await this.socialAccountAuth.openLogin('𝕏', 'redirectToXForPostsEntanglement');
    }
  }
  async emitLinkedInToggleEvent(){
    if (!this.linkedinEnabled || this.checkingLinkedInConnection) return;
    this.checkingLinkedInConnection = true;
    try {
      let data: any = await this.request.createRequestPost('getAuthLinkedInProfile', {});
      if (!this.linkedinEnabled) return;
      if (typeof data === 'string') data = JSON.parse(data);
      const profile = typeof data?.success === 'object' ? data.success : null;
      if (profile) {
        this.linkedin_profile_photo = profile.picture;
        this.linkedin_user_name = profile.name;
        this.linkedin_email = profile.email;
        this.linkedin_email_verification = profile.email_verified;
        return;
      }
    } catch (error) {
      console.error('Unable to check LinkedIn connection:', error);
    } finally {
      this.checkingLinkedInConnection = false;
    }

    this.linkedinEnabled = false;
    if (this.linkedin_toggleElement) this.linkedin_toggleElement.checked = false;
    if (window.confirm('Activaste la opción para publicar en LinkedIn. Para publicar contenido en tu cuenta de LinkedIn, primero debes iniciar sesión. ¿Quieres iniciar sesión ahora?')) {
      await this.socialAccountAuth.openLogin(
        'LinkedIn', 'redirectToLinkedInForEntanglement',
        { popup_section: this.formservice.popup_section }
      );
    }
  }
  async emitFacebookToggleEvent(){
    if (!this.facebookEnabled || this.checkingFacebookConnection) return;
    this.checkingFacebookConnection = true;
    try {
      let data: any = await this.request.createRequestPost('getAuthFacebookProfile', {});
      if (!this.facebookEnabled) return;
      if (typeof data === 'string') data = JSON.parse(data);
      if (data?.success) {
        const profile = typeof data.success === 'object' ? data.success : {};
        const tpUser = data.tp_user || {};
        this.facebook_account_id = profile.id || tpUser.id || tpUser.user_id || tpUser.account_id;
        this.facebook_profile_photo = profile.picture || tpUser.profile_image_url || tpUser.picture;
        this.facebook_user_name = profile.name || profile.username || tpUser.name || tpUser.username || this.facebook_account_id;
        this.facebook_email = profile.email || tpUser.email || null;
        this.facebook_email_verification = profile.email_verified || tpUser.email_verified;
        return;
      }
    } catch (error) {
      console.error('Unable to check Facebook connection:', error);
    } finally {
      this.checkingFacebookConnection = false;
    }

    this.facebookEnabled = false;
    if (this.facebook_toggleElement) this.facebook_toggleElement.checked = false;
    if (window.confirm('Activaste la opción para publicar en Facebook. Para publicar contenido en tu cuenta de Facebook, primero debes iniciar sesión. ¿Quieres iniciar sesión ahora?')) {
      await this.socialAccountAuth.openLogin(
        'Facebook', 'redirectToFacebookForPostsEntanglement',
        { popup_section: this.formservice.popup_section }
      );
    }
  }
  async emitYouTubeToggleEvent(){
    if (!this.youTubeEnabled || this.checkingYouTubeConnection) return;
    this.checkingYouTubeConnection = true;
    try {
      let data: any = await this.request.createRequestPost('getAuthYouTubeToken', {});
      if (!this.youTubeEnabled) return;
      if (typeof data === 'string') data = JSON.parse(data);
      if (data?.success) {
        this.youtube_email = data.tp_username || data.email || data.success?.email;
        return;
      }
    } catch (error) {
      console.error('Unable to check YouTube connection:', error);
    } finally {
      this.checkingYouTubeConnection = false;
    }

    this.youTubeEnabled = false;
    if (this.youTube_toggleElement) this.youTube_toggleElement.checked = false;
    if (window.confirm('Activaste la opción para publicar en YouTube. Para publicar contenido en tu cuenta de YouTube, primero debes iniciar sesión con Google. ¿Quieres iniciar sesión ahora?')) {
      try {
        await this.googleAccountAuth.openGoogleAuthentication('youtube');
      } catch (error) {
        console.error('Unable to start YouTube authentication:', error);
        window.alert('No pudimos abrir el inicio de sesión de YouTube. Inténtalo nuevamente.');
      }
    }
  }
  async emitTikTokToggleEvent(){
    if (!this.tiktokEnabled || this.checkingTikTokConnection) return;
    this.checkingTikTokConnection = true;
    try {
      let data: any = await this.request.createRequestPost('getAuthTikTokProfile', {});
      if (!this.tiktokEnabled) return;
      if (typeof data === 'string') data = JSON.parse(data);
      const creator = data?.success?.data;
      if (creator?.creator_username) {
        const user = data?.genuine_data?.data?.user || {};
        this.tiktok_profile_photo = creator.creator_avatar_url;
        this.tiktok_username = creator.creator_username;
        this.tiktok_privacy_level_options = creator.privacy_level_options;
        this.tiktok_followers = user.follower_count;
        this.tiktok_following = user.following_count;
        this.tiktok_likes_count = user.likes_count;
        this.tiktok_video_count = user.video_count;
        this.tiktok_is_verified = user.is_verified;
        this.tiktok_profile_deep_link = user.profile_deep_link;
        this.tiktok_profile_bio_description = user.bio_description;
        this.autoSetTikTokSubTogglesBasedOnMedia();
        return;
      }
    } catch (error) {
      console.error('Unable to check TikTok connection:', error);
    } finally {
      this.checkingTikTokConnection = false;
    }

    this.tiktokEnabled = false;
    this.tiktokPhotoEnabled = false;
    this.tiktokVideoEnabled = false;
    if (this.TikTok_toggleElement) this.TikTok_toggleElement.checked = false;
    if (window.confirm('Activaste la opción para publicar en TikTok. Para publicar contenido en tu cuenta de TikTok, primero debes iniciar sesión. ¿Quieres iniciar sesión ahora?')) {
      await this.socialAccountAuth.openLogin(
        'TikTok', 'redirectToTikTokForEntanglement',
        { popup_section: this.formservice.popup_section }
      );
    }
  }
  emitInstagramToggleEvent(){
    if (this.instagramEnabled && !this.instagram_user_name){
      this.request.createRequestPost('getAuthInstagramProfile', {corp:true})
      .then((data) => {
        if (data && typeof data === 'string') {
          try {
            data = JSON.parse(data);
            console.log('getRecordByToken ios:',data);
          } catch (error) {
            console.error("Error parsing data:", error);
          }
          }
      // Open the login URL in the system browser
    
      console.log(data);
     
      if(data.success){
        this.instagram_profile_photo=data.tp_user.profile_picture_url;
        this.instagram_user_name=data.tp_user.username;
        this.instagram_biography=data.tp_user.biography;
        this.instagram_followers=data.tp_user.followers_count;
        this.instagram_follows=data.tp_user.follows_count;
        this.instagram_media_count=data.tp_user.media_count;
        // ensure subs are set for the detected media when profile becomes available (first auth on toggle)
        this.autoSetInstagramSubTogglesBasedOnMedia();
        Swal2.fire({
          title: 'Usuario de Instagram',
          text: 'The user has been authenticated',
          icon: 'success',
          toast: true,
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
        });
      }else{
      this.socialAccountAuth.offerLogin(
        'Instagram',
        'redirectToInstagramForThirdPartyEntanglement',
        { popup_section: this.formservice.popup_section }
      );
      if (this.instagram_toggleElement) this.instagram_toggleElement.checked = false;
      this.instagramEnabled = false;
      this.instagramStoriesEnabled = false;
      this.instagramReelsEnabled = false;
      }
  
    }).catch((error) => {
      // Untoggle the ion-toggle element by setting its checked property to false
      if (this.instagram_toggleElement) this.instagram_toggleElement.checked = false;
      this.instagramEnabled = false;
      this.instagramStoriesEnabled = false;
      this.instagramReelsEnabled = false;
      // Handle the error here, such as displaying a message to the user or logging it for further investigation.
    });
    }

    // Auto-set the appropriate sub-toggle (story vs reel) based on the media type of the current post.
    // This executes when the main toggle is changed (via ionChange -> emit), for immediate UX feedback.
    // Previously was (incorrectly) only at post-click time inside thirdPartyPost.
    if (this.instagramEnabled) {
      this.autoSetInstagramSubTogglesBasedOnMedia();
    }
  }
  open_android_iab(loginUrl){
    const browser = window.open(loginUrl, '_blank', 'location=yes,toolbar=yes');

    const interval = setInterval(() => {
      if (browser?.closed) {
      clearInterval(interval);
      console.log('Window was closed.');
      }
    }, 500);
    }
  async openURL(url){
    if (Capacitor.getPlatform() !== 'android') {
      await Browser.open({ url :url});
    }else{
      this.open_android_iab(url);
      }
  }
  emit_tiktok_Content_Disclosure_Setting(){
    if(this.tiktok_privacy === 'SELF_ONLY'){
      Swal2.fire({
        title: 'Publicación en TikTok',
        text: 'La visibilidad del contenido de marca no puede ser privada.',
        icon: 'warning',
        toast: true,
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
     
    }
  }

  /**
   * Detects whether the current publication's media (the one that will be posted)
   * is an image or a video. Used to auto-configure sub-toggles for TikTok/Instagram
   * when their main toggle changes.
   * Mirrors the pub_type ('imagen' | 'video') logic used at upload/post time.
   */
  private getPubTypeForCurrentMedia(): 'imagen' | 'video' {
    // Video takes precedence if the formservice video preview/src is set
    if (this.formservice && this.formservice.Capacitor_convertFileSrc_video) {
      return 'video';
    }

    // The 'imagen' var holds the converted src for picked multimedia (can be img or vid)
    if (this.imagen) {
      if (this.isVideo(this.imagen)) {
        return 'video';
      }
      if (this.isImage(this.imagen)) {
        return 'imagen';
      }
    }

    // Fallback: inspect the multimedia array from formservice (MediaItem has type/typeData)
    if (this.formservice && this.formservice.multimedia && this.formservice.multimedia.length > 0) {
      const el: any = this.formservice.multimedia[0];
      const td = ((el && (el.typeData || el.type)) || '').toString().toLowerCase();
      if (td.includes('video')) {
        return 'video';
      }
      if (td.includes('image') || td.includes('photo')) {
        return 'imagen';
      }
    }

    // Laniakea cover url (used e.g. for browsers when no picked media) is always image
    if (this.isValidLaniakeaImageUrl && this.isValidLaniakeaImageUrl()) {
      return 'imagen';
    }

    // Default to imagen (common case, and matches many post flows)
    return 'imagen';
  }

  private getSelectedThirdPartyPlatforms(mediaItems: any[]): string[] {
    const mediaTypes = new Set((mediaItems || []).map(item => {
      const mimeType = String(item?.blob?.type || '').toLowerCase();
      const filename = String(item?.filename || '').toLowerCase();
      if (mimeType.startsWith('video/') || this.isVideo(filename)) return 'video';
      if (mimeType.startsWith('image/') || this.isImage(filename)) return 'image';
      return '';
    }).filter(Boolean));
    const hasVideo = mediaTypes.has('video');
    const hasImage = mediaTypes.has('image');
    const platforms: string[] = [];

    if (this.browsersEnabled) platforms.push('Browsers');
    if (this.threadsEnabled && (hasImage || hasVideo)) platforms.push('Threads');
    if (this.linkedinEnabled && (hasImage || hasVideo)) platforms.push('LinkedIn');
    if (this.facebookEnabled && (hasImage || hasVideo)) platforms.push('Facebook');
    if (this.twitterEnabled && (hasImage || hasVideo)) platforms.push('X');
    if (this.youTubeEnabled && hasVideo) platforms.push('YouTube');
    if (this.tiktokEnabled && ((hasImage && this.tiktokPhotoEnabled) || (hasVideo && this.tiktokVideoEnabled))) {
      platforms.push('TikTok');
    }
    if (this.instagramEnabled && (hasImage || (hasVideo && (this.instagramStoriesEnabled || this.instagramReelsEnabled)))) {
      platforms.push('Instagram');
    }

    return platforms;
  }

  private autoSetTikTokSubTogglesBasedOnMedia() {
    if (!this.tiktokEnabled) {
      return;
    }
    const mediaType = this.getPubTypeForCurrentMedia();
    if (mediaType === 'imagen') {
      this.tiktokPhotoEnabled = true;
      this.tiktokVideoEnabled = false;
      this.applyTikTokPhotoDefaults();
    } else {
      this.tiktokVideoEnabled = true;
      this.tiktokPhotoEnabled = false;
      this.applyTikTokVideoDefaults();
    }
  }

  private applyTikTokVideoDefaults(): void {
    this.video_cover_timestamp_ms = 1;
    this.tiktokDuetEnabled = true;
    this.tiktokStitchEnabled = true;
    this.tiktokDraftEnabled = false;
    this.tiktokDirectPost = true;

    this.tiktok_privacy = this.getTikTokPublicPrivacyOption();
  }

  private applyTikTokPhotoDefaults(): void {
    this.tiktokDraftEnabled = false;
    this.tiktokDirectPost = true;
    this.tiktok_comment_disabled = true;
    this.tiktok_privacy = this.getTikTokPublicPrivacyOption();
  }

  private getTikTokPublicPrivacyOption(): string {
    const privacyOptions = Array.isArray(this.tiktok_privacy_level_options)
      ? this.tiktok_privacy_level_options.map(option => String(option))
      : [];
    const publicOption = privacyOptions.find(option =>
      option.toUpperCase() === 'PUBLIC_TO_EVERYONE'
    ) || privacyOptions.find(option =>
      option.toUpperCase().includes('PUBLIC') && option.toUpperCase() !== 'SELF_ONLY'
    );
    return publicOption || 'PUBLIC_TO_EVERYONE';
  }

  private autoSetInstagramSubTogglesBasedOnMedia() {
    if (!this.instagramEnabled) {
      return;
    }
    const mediaType = this.getPubTypeForCurrentMedia();
    if (mediaType === 'imagen') {
      this.instagramStoriesEnabled = true;
      this.instagramReelsEnabled = false;
    } else {
      this.instagramReelsEnabled = true;
      this.instagramStoriesEnabled = true;
    }
  }

  public isCurrentInstagramMediaVideo(): boolean {
    return this.getPubTypeForCurrentMedia() === 'video';
  }

  private async createInstagramPhotoAsset(sourceUrl: string, index: number): Promise<string> {
    const response = await fetch(sourceUrl);
    if (!response.ok) {
      throw new Error(`No se pudo leer la imagen para Instagram (${response.status}).`);
    }
    const sourceBlob = await response.blob();
    const sourceObjectUrl = URL.createObjectURL(sourceBlob);

    try {
      const image = await new Promise<HTMLImageElement>((resolve, reject) => {
        const element = new Image();
        element.onload = () => resolve(element);
        element.onerror = () => reject(new Error('No se pudo decodificar la imagen para Instagram.'));
        element.src = sourceObjectUrl;
      });
      const aspectRatio = image.naturalWidth / image.naturalHeight;
      const minimumSupportedAspectRatio = 9 / 16;
      const maximumSupportedAspectRatio = 1.91;
      const isJpeg = sourceBlob.type.toLowerCase() === 'image/jpeg' || /\.jpe?g(?:$|[?#])/i.test(sourceUrl);
      const isCompliant = isJpeg
        && sourceBlob.size <= 8 * 1024 * 1024
        && image.naturalWidth >= 320
        && image.naturalWidth <= 1440
        && aspectRatio >= minimumSupportedAspectRatio
        && aspectRatio <= maximumSupportedAspectRatio;
      if (isCompliant) {
        return sourceUrl;
      }

      // Preserve the original aspect ratio whenever it is supported. We only
      // add padding for an extreme ratio outside the accepted range; no normal
      // portrait, square, landscape, or 9:16 image is forced into 4:5.
      const targetAspectRatio = Math.min(
        maximumSupportedAspectRatio,
        Math.max(minimumSupportedAspectRatio, aspectRatio)
      );
      const width = Math.min(1440, Math.max(320, image.naturalWidth));
      const height = Math.max(1, Math.round(width / targetAspectRatio));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');
      if (!context) {
        throw new Error('No se pudo preparar el lienzo de Instagram.');
      }
      if (targetAspectRatio !== aspectRatio) {
        context.fillStyle = '#000000';
        context.fillRect(0, 0, width, height);
      }
      const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
      const drawnWidth = Math.max(1, Math.round(image.naturalWidth * scale));
      const drawnHeight = Math.max(1, Math.round(image.naturalHeight * scale));
      context.drawImage(image, Math.round((width - drawnWidth) / 2), Math.round((height - drawnHeight) / 2), drawnWidth, drawnHeight);

      let instagramBlob: Blob | undefined;
      for (const quality of [0.92, 0.84, 0.76, 0.68]) {
        const candidate = await new Promise<Blob>((resolve, reject) => {
          canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('No se pudo codificar la imagen de Instagram.')), 'image/jpeg', quality);
        });
        instagramBlob = candidate;
        if (candidate.size <= 8 * 1024 * 1024) break;
      }
      if (!instagramBlob || instagramBlob.size > 8 * 1024 * 1024) {
        throw new Error('No se pudo crear una imagen de Instagram menor a 8 MB.');
      }

      const filename = `instagram-${Date.now()}-${index}.jpg`;
      const { link } = await this.uploadmultimedia.post(instagramBlob, filename);
      return link;
    } finally {
      URL.revokeObjectURL(sourceObjectUrl);
    }
  }

  private resetTikTokPhotoBatch(media: any[]): void {
    this.images_compatible_to_tiktok = [];
    this.tikTokPhotoUrls.clear();
    this.tikTokPhotoPosting = false;
    this.tikTokPhotoExpectedCount = this.tiktokEnabled && this.tiktokPhotoEnabled
      ? media.filter((item: any) => {
          const isPremium = item?.isPremium ?? this.formservice.normalpublication?.current_multimedia_status;
          return !isPremium && this.isImageUploadEntry(item);
        }).length
      : 0;
  }

  private async createTikTokPhotoAsset(sourceUrl: string, index: number): Promise<string> {
    const response = await fetch(sourceUrl);
    if (!response.ok) {
      throw new Error(`No se pudo leer la imagen para TikTok (${response.status}).`);
    }
    const sourceBlob = await response.blob();
    const sourceObjectUrl = URL.createObjectURL(sourceBlob);

    try {
      const image = await new Promise<HTMLImageElement>((resolve, reject) => {
        const element = new Image();
        element.onload = () => resolve(element);
        element.onerror = () => reject(new Error('No se pudo decodificar la imagen para TikTok.'));
        element.src = sourceObjectUrl;
      });

      const width = 1920;
      const height = 1080;
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');
      if (!context) {
        throw new Error('No se pudo preparar el lienzo de TikTok.');
      }

      // Keep the entire image visible. Letterboxing avoids silently cropping
      // product photos while guaranteeing TikTok receives an exact 1920×1080 JPEG.
      context.fillStyle = '#000000';
      context.fillRect(0, 0, width, height);
      const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
      const drawnWidth = Math.max(1, Math.round(image.naturalWidth * scale));
      const drawnHeight = Math.max(1, Math.round(image.naturalHeight * scale));
      context.drawImage(image, Math.round((width - drawnWidth) / 2), Math.round((height - drawnHeight) / 2), drawnWidth, drawnHeight);

      const tikTokBlob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('No se pudo codificar la imagen de TikTok.')), 'image/jpeg', 0.92);
      });
      const filename = `tiktok-${Date.now()}-${index}.jpg`;
      const { link } = await this.uploadmultimedia.post(tikTokBlob, filename);
      return link;
    } finally {
      URL.revokeObjectURL(sourceObjectUrl);
    }
  }

  private queueTikTokPhoto(sourceUrl: string, index: number, array: any[]): void {
    if (!this.tikTokPhotoExpectedCount) {
      this.resetTikTokPhotoBatch(array);
    }
    this.createTikTokPhotoAsset(sourceUrl, index)
      .then(link => {
        this.tikTokPhotoUrls.set(index, link);
        this.images_compatible_to_tiktok = Array.from(this.tikTokPhotoUrls.entries())
          .sort(([left], [right]) => left - right)
          .map(([, url]) => url);
        if (!this.tikTokPhotoPosting && this.images_compatible_to_tiktok.length === this.tikTokPhotoExpectedCount) {
          this.tikTokPhotoPosting = true;
          this.thirdPrtyMedia = this.images_compatible_to_tiktok[0];
          this.thirdPrtyMediaType = 'imagen';
          this.postToTikTok();
        }
      })
      .catch(error => {
        console.error('TikTok image normalization failed:', error);
        this.setThirdPartyPublishStatus(
          'error',
          'TikTok: the image could not be prepared in the required 1920 × 1080 format.',
          7000,
        );
      });
  }

  /**
   * Reuse the S3 object already uploaded for the publication and attach it to
   * the user's active Laniakea Story. A new Story state is created only when
   * Instagram Stories is enabled, so one action publishes to both services.
   */
  private async publishToLaniakeaStory(mediaUrl: string, mediaType: string): Promise<void> {
    const storyResponse: any = await this.publicationService.postPublication({
      publication_type: 'state',
      data: {
        title: this.formservice.title || 'Historia',
      },
    });

    let storyData: any = storyResponse;
    if (typeof storyData === 'string') {
      storyData = JSON.parse(storyData);
    }

    // Native clients and the web request service can return the JSON model
    // directly, while some deployments wrap it in `data` or `result`.
    // Normalize all supported response shapes before reading the IDs.
    storyData = storyData?.data && !storyData.id ? storyData.data : storyData;
    storyData = storyData?.result && !storyData.id ? storyData.result : storyData;

    const publicationId = Number(
      storyData?.id ?? storyData?.publication_id ?? storyData?.publication?.id
    );
    const stateId = Number(
      storyData?.state_id ?? storyData?.state?.id ?? storyData?.story?.state_id
    );
    if (!publicationId || !stateId) {
      throw new Error('Laniakea no devolvió los identificadores de la historia.');
    }

    await this.request.createRequestPost('publications.multimedia', {
      route: mediaUrl,
      size: 800,
      type: mediaType === 'video' ? 'video' : 'imagen',
      publication_type: 'story',
      state_id: stateId,
      publication_id: publicationId,
      is_premium: false,
    });
  }

  thirdPartyPost(is_premium_m, pub_type, link, index, array, publication_ids, posterLink?: string){
    if (this.getSelectedThirdPartyPlatforms(array || []).length > 0) {
      this.setThirdPartyPublishStatus('processing', 'Preparing selected third-party publications…');
    }

    if (this.instagramStoriesEnabled && !is_premium_m) {
      this.publishToLaniakeaStory(link, pub_type).catch(error => {
        console.error('Laniakea Story creation failed:', error);
        this.showInstagramPublishError('STORIES', error);
      });
    }

    if(this.tiktokEnabled && !is_premium_m && this.tiktokPhotoEnabled && pub_type === 'imagen'){
      this.setThirdPartyPublishStatus('processing', 'Preparing your photos for TikTok…');
      this.queueTikTokPhoto(link, index, array);
        } 
      else if(this.tiktokEnabled && !is_premium_m && this.tiktokVideoEnabled && pub_type !== 'imagen'){
        this.setThirdPartyPublishStatus('processing', 'Sending your video to TikTok…');
        this.thirdPrtyMedia=link;
        this.thirdPrtyMediaType=pub_type;
        this.postToTikTok();
      }
    
      if(!is_premium_m){
        this.thirdPrtyMedia=link;
        this.thirdPrtyMediaType=pub_type;
        this.publication_id= publication_ids;
        if(this.browsersEnabled && !this.wixPostSent){
          this.setThirdPartyPublishStatus('processing', 'Sending your publication to browsers…');
          this.PostOnWix(pub_type === 'imagen' ? link : posterLink);
        }
        if(this.threadsEnabled){
          this.thirdPrtyMediaType=pub_type;
          this.checkImageCompatibiltyWithMeta(pub_type,link);
          this.setThirdPartyPublishStatus('processing', 'Sending your publication to Threads…');
          this.PostOnThreads();
        }
        if(this.linkedinEnabled){
          this.setThirdPartyPublishStatus('processing', 'Sending your publication to LinkedIn…');
          this.postToLinkedIn();
        }
        if(this.facebookEnabled){
          this.setThirdPartyPublishStatus('processing', 'Sending your publication to Facebook…');
          this.thirdPrtyMedia=link;
          this.thirdPrtyMediaType=pub_type;
          this.postToFacebook();
        }
        if (this.twitterEnabled){
          this.setThirdPartyPublishStatus('processing', 'Sending your publication to 𝕏…');
          this.postToX();
        }
       
      }
      if (this.youTubeEnabled && !is_premium_m){
        this.setThirdPartyPublishStatus('processing', 'Sending your publication to YouTube…');
          this.thirdPrtyMedia=link;
          this.thirdPrtyMediaType=pub_type;
          if(pub_type==='video'){
            this.postToYouTube();
          }
       
     
      }
      if (this.instagramEnabled && !is_premium_m &&
          (pub_type === 'imagen' || this.instagramStoriesEnabled ||
            (this.instagramReelsEnabled && pub_type === 'video'))) {
        // Feed photos are preflighted before creating a Meta media container.
        // A compliant original is reused; any other image is normalized first.
        if (pub_type === 'imagen') {
          this.createInstagramPhotoAsset(link, index)
            .then(instagramLink => {
              this.postToInstagramDestination('FEED', instagramLink, 'imagen');
              // Stories already use their own successful path. Keep their
              // source untouched instead of forcing the 4:5 feed derivative
              // into a 9:16-oriented destination.
              if (this.instagramStoriesEnabled) {
                this.postToInstagramDestination('STORIES', link, 'imagen');
              }
            })
            .catch(error => {
              console.error('Instagram image normalization failed:', error);
              this.showInstagramPublishError('FEED', error);
            });
        } else {
          this.postToIG(link, pub_type);
        }
      }
  }
  PostOnWix(uploadedImageUrl?: string){
    const laniakeaImageUrl = (this.laniakea_image_url || uploadedImageUrl || '').trim();
    const title = this.wixPostTitle || this.getThirdPartyPublicationTitle();
    const description = this.wixPostDescription || this.getThirdPartyPublicationDescription();
    this.wixPostSent = true;


    this.request.createRequestPost('getAuthWixProfile', {navigator_language:this.navigator_language,title, description,publication_id: this.publication_id,laniakea_image_url: laniakeaImageUrl})
    .then((data) => {
      const result = this.parseInstagramResponse(data);
      if (result?.success === false || result?.error) {
        this.setThirdPartyPublishStatus('error', `Browsers: ${result?.message || result?.error || 'The publication was rejected.'}`, 7000);
        return;
      }
      this.setThirdPartyPublishStatus('success', 'Your publication was sent to browsers.', 5000);
    })
    .catch(error => this.setThirdPartyPublishStatus('error', `Browsers: ${error?.message || 'The publication could not be sent.'}`, 7000));
          
  
  }

  private isImageUploadEntry(item: any): boolean {
    const blobType = item?.blob?.type || '';
    const filename = item?.filename || '';

    if (blobType.toLowerCase().startsWith('image/')) {
      return true;
    }

    return this.isImage(filename);
  }

  private isValidLaniakeaImageUrl(): boolean {
    const value = (this.laniakea_image_url || '').trim();
    if (!value) {
      return false;
    }

    try {
      const url = new URL(value);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (error) {
      return false;
    }
  }
checkImageCompatibiltyWithMeta(pub_type,link){
  if(pub_type!=='video'){
    this.setThirdPartyPublishStatus('processing', 'Checking image compatibility for Instagram…');
  const extension = link.split('.').pop()?.toLowerCase();
  
  // Check if the extension matches the image formats you want to identify (JPEG/JPG)
  if (extension === 'jpeg' || extension === 'jpg') {
      // Create a new Image element
      const img = new Image();
  
      // Set the src attribute to the image URL
      img.src = link;
  
      // Once the image is loaded, perform the necessary checks
      img.onload = function () {
          // Check width and height for aspect ratio
          const width = img.width;
          const height = img.height;
          const aspectRatio = width / height;
  
          // Check file size by making a HEAD request to get content length (file size in bytes)
          fetch(link, { method: 'HEAD' })
              .then(response => {
                  const fileSizeBytes = response.headers.get('content-length');
  
                  // Check if fileSizeBytes is not null or undefined
                  if (fileSizeBytes) {
                      const fileSizeMB = parseInt(fileSizeBytes) / (1024 * 1024); // Convert to MB
  
                      // Define the required aspect ratio and width range
                      const minAspectRatio = 4 / 5;
                      const maxAspectRatio = 1.91 / 1;
                      const minWidth = 320;
                      const maxWidth = 1440;
                      const maxFileSizeMB = 8; // Maximum file size is 8 MB
  
                      // Perform the validation checks
                      if (
                          fileSizeMB <= maxFileSizeMB &&
                          aspectRatio >= minAspectRatio && aspectRatio <= maxAspectRatio &&
                          width >= minWidth && width <= maxWidth
                      ) {
                        console.log('Image is valid: meets all criteria.');
                      } else {
                          console.log('Image is invalid: does not meet criteria.');
                      }
                  } else {
                      console.error('Failed to retrieve file size.');
                  }
              })
              .catch(error => {
                  console.error('Error fetching image size:', error);
              });
      };
  
      // Handle image load error
      img.onerror = function () {
          console.error('Failed to load image.');
      };
  } else {
      console.log('Invalid image format. Only JPEG/JPG are supported.');
  }
  }
}
  async emitThreadsToggleEvent(){
    if (!this.threadsEnabled || this.checkingThreadsConnection) return;
    this.checkingThreadsConnection = true;
    try {
      let data: any = await this.request.createRequestPost('redirectToThreadsLoginForEntanglement', { auth: true });
      if (!this.threadsEnabled) return;
      if (typeof data === 'string') data = JSON.parse(data);
      if (data?.id) {
        this.threads_id = data.id;
        return;
      }
    } catch (error) {
      console.error('Unable to check Threads connection:', error);
    } finally {
      this.checkingThreadsConnection = false;
    }

    this.threadsEnabled = false;
    if (this.threads_toggleElement) this.threads_toggleElement.checked = false;
    if (window.confirm('Activaste la opción para publicar en Threads. Para publicar contenido en tu cuenta de Threads, primero debes iniciar sesión. ¿Quieres iniciar sesión ahora?')) {
      await this.socialAccountAuth.openLogin(
        'Threads', 'redirectToThreadsLoginForEntanglement', { login: true }
      );
    }
  }
  PostOnThreads() {
    // Determine media type and URL
    const mediaUrl = this.thirdPrtyMedia;
    const caption = `${this.formservice.title} ${this.formservice.description}`.slice(0, 480);

    let mediaType: string;
  
    if (this.thirdPrtyMediaType === 'imagen') {
      mediaType = 'IMAGE';
    } else if (this.thirdPrtyMediaType === 'video') {
      mediaType = 'VIDEO';
    } else {
      console.error('Unsupported media type');
      return;
    }
  
    // Check if Threads integration is enabled
    if (this.threadsEnabled) {
      this.setThirdPartyPublishStatus('processing', 'Sending to Threads. Preparing your media…');

      // Function to check post status recursively
      const checkPostStatus = (mediaId: string) => {
        this.request
          .createRequestPost('postToThreadsProfile', { mediaContainerId:mediaId })
          .then((data: any) => {
            if (data && typeof data === 'string') {
              try {
                data = JSON.parse(data);
                console.log('getRecordByToken ios:',data);
              } catch (error) {
                console.error("Error parsing data:", error);
              }
              }
            console.log('THREADS_STATUS_RESPONSE', data);
  
            if (data.post_complete === false) {
              console.log('Media is still processing, retrying in 6 seconds...');
              this.setThirdPartyPublishStatus('processing', 'Threads is still processing your media. Checking again automatically…');
              setTimeout(() => checkPostStatus(mediaId), 6000); // Retry after 6 seconds
            } else if (data.post_complete== true) {
              // Show success message when post is complete
              this.setThirdPartyPublishStatus('success', 'Your publication is live on Threads.', 5000);
            } else {
              console.error('Error posting to Threads:', data);
              this.setThirdPartyPublishStatus('error', 'Threads could not publish this media. Please try again.', 7000);
            }
          })
          .catch((error: any) => {
            console.error('Error during status check:', error);
            this.setThirdPartyPublishStatus('error', 'Threads status could not be verified right now. Please try again.', 7000);
          });
      };
  
      // Initial request to post media
      this.request
        .createRequestPost('postToThreadsProfile', { mediaUrl, caption, mediaType })
        .then((data: any) => {
          if (data && typeof data === 'string') {
            try {
              data = JSON.parse(data);
              console.log('getRecordByToken ios:',data);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
          console.log('THREADS_INITIAL_RESPONSE', data);
  
          if (data.mediaContainerId) {
            // Start checking post status if media ID is available
            checkPostStatus(data.mediaContainerId);
          } else {
            console.error('Failed to create initial post. No media_id returned.');
            this.setThirdPartyPublishStatus('error', 'Threads could not start this publication. Please try again.', 7000);
          }
        })
        .catch((error: any) => {
          console.error('Error creating initial post:', error);
          this.setThirdPartyPublishStatus('error', 'Threads upload could not start. Please try again.', 7000);
        });
    }
  }
  
}
